webpackJsonp([1],{

/***/ "+eEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Keyword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var Keyword = function () {
  function Keyword(data) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Keyword);

    if (data !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
    }
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Keyword, [{
    key: "prepareForSend",
    value: function prepareForSend() {
      var data = _.cloneDeep(this);
      return data;
    }
  }]);

  return Keyword;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "+rOP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-default"},[_c('div',{staticClass:"box-body"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"pull-right"},[_c('h4',[_c('span',{staticClass:"label label-primary",on:{"click":_vm.next}},[_vm._v("\n                  >\n                ")])])]),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('router-link',{attrs:{"to":{ name: 'reelsShow', params: { id: _vm.reel.id }},"tag":"h4"}},[_c('span',{staticClass:"label label-primary"},[_c('strong',[_vm._v(_vm._s(_vm.reel.identificativo))])])])],1),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('h4',[_c('span',{staticClass:"label label-primary",on:{"click":_vm.prev}},[_vm._v("\n                  <\n                ")])])]),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('router-link',{attrs:{"to":{ name: 'fundsShow', params: { id: _vm.fund.id }},"tag":"h4"}},[_c('span',{staticClass:"label label-primary"},[_c('strong',[_vm._v(_vm._s(_vm.fund.denominazione))])])])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('sequences-form',{attrs:{"sequence":_vm.sequence,"reel":_vm.reel,"disabled":_vm.disabled,"showLabels":true,"showMap":_vm.showMap},on:{"activate-mod":function($event){return _vm.activateMod()},"click":_vm.updateSequence,"update-sequence-prop":_vm.updateSequenceProp}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Cq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_macrotags__ = __webpack_require__("68s8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'macrotag', 'loader', 'showLabels'],
  methods: {
    click: function click() {
      this.$emit('click', this.macrotag);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.macrotag);
    }
  },
  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      macrotags: []
    };
  },

  computed: {
    donazione_tipi: function donazione_tipi() {
      return this.$store.state.decoder.decoders['_dDonationTypes'];
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_macrotags__["a" /* default */].index().then(function (response) {
      _this.macrotags = response.data.data;
    });
  },

  components: {}
});

/***/ }),

/***/ "/Lmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Macrotag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var Macrotag = function () {
  function Macrotag(data) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Macrotag);

    if (data !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
    }
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Macrotag, [{
    key: "prepareForSend",
    value: function prepareForSend() {
      return _.cloneDeep(this);
    }
  }]);

  return Macrotag;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "/VFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_collections__ = __webpack_require__("mSmg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      columns: ['title', 'description', 'sequences', 'actions'],
      options: {
        headings: {
          'title': 'Titolo',
          'description': 'Descrizione',
          'sequences': 'N sequenze'
        },
        sortable: ['titolo', 'descrizione'],
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_collections__["a" /* default */].index(query);
        }
      },
      loading: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Raccolte inserite',
      createButton: {
        display: true,
        text: 'Nuova raccolta',
        to: 'collection'
      }
    });
  },


  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_collections__["a" /* default */].delete(id).then(function (response) {
          _this.$refs.collections.refresh();
          toastr.success('La raccolta è stata rimossa correttamente');
          _this.loading = false;
        }).catch(function (response) {
          _this.loading = false;
        });
      }
    },
    toggleLoading: function toggleLoading() {
      // this.loading = !this.loading
    },
    showCollection: function showCollection(row) {
      this.$router.push({ name: 'collectionsShow', params: { id: row.row.id } });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "/Ygb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/cB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/fgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_persons__ = __webpack_require__("4eBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("hqyI");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    personsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },

  data: function data() {
    return {
      person: false,
      disabled: true,
      interval: null
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.person = response;
    });
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Persone inserite',
      createButton: {
        display: true,
        text: 'Nuova persona',
        to: '/person'
      }
    });
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].update(_this2.$route.params.id, _this2.person);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updatePerson: function updatePerson() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].update(this.$route.params.id, this.person).then(function (response) {
        toastr.success('La persona è stata salvata correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__("gkTP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("X/gF");
function injectStyle (ssrContext) {
  __webpack_require__("qoDK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("u7Vc");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "09nQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Kyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("7q3b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5847a042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("atvy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5847a042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0hpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("GQLb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9ef6f10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("fa5V");
function injectStyle (ssrContext) {
  __webpack_require__("7a9Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9ef6f10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0nBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("s7RQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347b1932_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("kodO");
function injectStyle (ssrContext) {
  __webpack_require__("n4Di")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-347b1932"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347b1932_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1wuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('places-form',{attrs:{"place":_vm.place,"loader":_vm.loader,"showLabels":false},on:{"click":function($event){return _vm.storePlace(_vm.place)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2U5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("3UXq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d6f666_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("k307");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d6f666_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2gHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "34tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"main-sidebar"},[_c('section',{staticClass:"sidebar"},[_c('ul',{staticClass:"sidebar-menu tree",attrs:{"data-widget":"tree"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'fundsIndex'}}},[_c('i',{staticClass:"fa fa-list fa-fw"}),_vm._v(" "),_c('span',[_vm._v("Fondi")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'collectionsIndex'}}},[_c('i',{staticClass:"fa fa-map-o fa-fw"}),_vm._v(" "),_c('span',[_vm._v("Mappa")])])],1),_vm._v(" "),_c('li',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('router-link',{attrs:{"to":{ name: 'personsIndex'}}},[_c('i',{staticClass:"fa fa-male fa-fw"}),_vm._v(" "),_c('span',[_vm._v("Persone")])]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('router-link',{attrs:{"to":{ name: 'placesIndex'}}},[_c('i',{staticClass:"fa fa-map-marker fa-fw"}),_vm._v(" "),_c('span',[_vm._v("Luoghi")])]):_vm._e()],1),_vm._v(" "),(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('li',{staticClass:"treeview"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"treeview-menu",staticStyle:{"display":"none"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'macrotagsIndex'}}},[_c('i',{staticClass:"fa fa-circle-o"}),_vm._v(" "),_c('span',[_vm._v("Macrotag")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'microtagsIndex'}}},[_c('i',{staticClass:"fa fa-circle-o"}),_vm._v(" "),_c('span',[_vm._v("Microtag")])])],1)])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"treeview"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"treeview-menu",staticStyle:{"display":"none"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'fundsSearch'}}},[_c('i',{staticClass:"fa fa-circle-o"}),_vm._v(" "),_c('span',[_vm._v("Fondi")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'reelsSearch'}}},[_c('i',{staticClass:"fa fa-circle-o"}),_vm._v(" "),_c('span',[_vm._v("Bobine")])])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-hashtag"}),_vm._v(" "),_c('span',[_vm._v("Tags")]),_vm._v(" "),_c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v("Cerca")]),_vm._v(" "),_c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3GEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_persons__ = __webpack_require__("4eBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_sequences__ = __webpack_require__("WBeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers__ = __webpack_require__("rm6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_fineuploader_dropzone__ = __webpack_require__("UNH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker__ = __webpack_require__("fv+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__("I7CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Description_vue__ = __webpack_require__("au+E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_masked_input__ = __webpack_require__("4q2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_collections__ = __webpack_require__("mSmg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Import this component

// Import date picker css







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'sequence', 'loader', 'showLabels', 'reel', 'showMap'],
  methods: {
    save: function save() {
      this.sequence.reel_id = this.reel.id;
      this.$emit('click', this.sequence);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.sequence);
    },
    delImage: function delImage(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_sequences__["a" /* default */].deleteImage(this.sequence.id, id).then(function (response) {
        _this.reel.sequenceimages = response.data.data.sequenceimages;
        toastr.success('L\'immagine è stata rimossa correttamente');
      }).catch(function (response) {});
    },
    setPlace: function setPlace(place) {
      var _this2 = this;

      this.place = place;
      this.$refs.mapRef.$mapPromise.then(function (map) {
        map.panTo({ lat: _this2.place.geometry.location.lat(), lng: _this2.place.geometry.location.lng() });
        _this2.usePlace();
      });
    },
    usePlace: function usePlace() {
      if (this.place) {
        this.marker = {
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          }
        };
        this.place = null;
        this.sequence.lat = this.marker.position.lat;
        this.sequence.lng = this.marker.position.lng;
      }
    },
    markerDragEnd: function markerDragEnd(marker) {
      this.sequence.lat = marker.latLng.lat();
      this.sequence.lng = marker.latLng.lng();
    },
    collectionsFind: function collectionsFind(query) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_11__api_collections__["a" /* default */].select(query).then(function (response) {
        _this3.collections = response.data.data;
      });
    }
  },

  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      persons: [],
      uploader: new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: []
      }),
      videoUploader: new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: []
      }),
      place: null,
      marker: {
        position: {
          lat: 45.69610605462603,
          lng: 9.673149926953101
        }
      },
      collections: [],
      uploading: false
    };
  },


  watch: {
    sequence: function sequence(val) {
      var _this4 = this;

      if (this.showLabels && val.lat !== null && val.lng !== null) {
        this.marker = {
          position: {
            lat: val.lat,
            lng: val.lng
          }
        };
      }
      this.uploader = new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: {
          request: {
            endpoint: "https://api.cinescatti.it/v1" + '/sequences/' + val.id + '/sequenceimage',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'image'
          },
          callbacks: {
            onComplete: function onComplete(id, name, response) {
              _this4.sequence.sequenceimages = response.data.sequenceimages;
            }
          }
        }
      });
      this.videoUploader = new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: {
          request: {
            endpoint: "https://api.cinescatti.it/v1" + '/sequences/' + val.id + '/video',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'video'
          },
          callbacks: {
            onProgress: function onProgress() {
              _this4.uploading = true;
            },
            onComplete: function onComplete(id, name, response) {
              _this4.uploading = false;
              _this4.sequence.video = response.data.video;
              _this4.$emit('update-sequence-prop', _this4.sequence);
            }
          }
        }
      });
    }
  },

  computed: {
    yn: function yn() {
      return this.$store.state.decoder.decoders['_dYesNo'];
    },
    tab1Class: function tab1Class() {
      return { active: !this.showMap };
    },
    tab2Class: function tab2Class() {
      return { active: this.showMap };
    }
  },

  beforeCreate: function beforeCreate() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].index().then(function (response) {
      _this5.persons = response.data.data;
    });
  },


  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a,
    Description: __WEBPACK_IMPORTED_MODULE_9__components_Description_vue__["a" /* default */],
    MaskedInput: __WEBPACK_IMPORTED_MODULE_10_vue_masked_input__["a" /* default */],
    Dropzone: __WEBPACK_IMPORTED_MODULE_4_vue_fineuploader_dropzone__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "3UXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_places__ = __webpack_require__("sWWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("YO57");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    placesForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },

  data: function data() {
    return {
      place: false,
      disabled: true,
      interval: null
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_places__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.place = response;
    });
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Luoghi inseriti',
      createButton: {
        display: true,
        text: 'Nuovo luogo',
        to: '/place'
      }
    });
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_places__["a" /* default */].update(_this2.$route.params.id, _this2.place);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updatePlace: function updatePlace() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_places__["a" /* default */].update(this.$route.params.id, this.place).then(function (response) {
        toastr.success('Il luogo è stato salvato correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "3foD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("o3Ph");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b9cd1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("gq5M");
function injectStyle (ssrContext) {
  __webpack_require__("yAC8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12b9cd1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b9cd1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3gx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_reels__ = __webpack_require__("R3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_reels__ = __webpack_require__("R3Pa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReelsTab',
  props: {
    requestFunction: Function
  },
  data: function data() {
    return {
      columns: ['id', 'identificativo', 'titolo_originale', 'titolo_attribuito', 'formato', 'cromatismo', 'suono', 'lunghezza', 'durata', 'digit', 'restauro', 'catalogato', 'actions'],
      options: {
        saveState: false,
        headings: {
          'titolo_originale': 'Titolo proprio'
        },
        sortable: ['identificativo', 'titolo_originale', 'titolo_attribuito', 'formato', 'lunghezza', 'durata', 'digit', 'restauro', 'catalogato'],
        requestFunction: this.$props.requestFunction,
        perPage: 200,
        orderBy: {
          column: 'identificativo',
          ascending: false
        }
      },
      loading: false,
      massSelected: [],
      massParam: null,
      massValue: null,
      saveMassParamLoader: false
    };
  },


  methods: {
    showReel: function showReel(row) {
      this.$router.push({ name: 'reelsShow', params: { id: row.row.id } });
      if (row.row.fund !== undefined) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* default */].SET_ACTUAL_FUND, _.cloneDeep(row.row.fund.data));
      }
    },
    refresh: function refresh() {
      this.$refs.reels.refresh();
    },
    toggleLoading: function toggleLoading() {
      this.loading = !this.loading;
    },
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.toggleLoading();
        __WEBPACK_IMPORTED_MODULE_0__api_reels__["a" /* default */].delete(id).then(function (response) {
          _this.toggleLoading();
          _this.$refs.reels.refresh();
          toastr.success('La bobina è stata rimossa correttamente');
        }).catch(function (response) {
          _this.toggleLoading();
        });
      }
    },
    saveMassParam: function saveMassParam() {
      var _this2 = this;

      this.saveMassParamLoader = true;
      return __WEBPACK_IMPORTED_MODULE_2__api_reels__["a" /* default */].updateMassive(this.massParam, this.massValue, this.massSelected).then(function () {
        _this2.refresh();
      }).finally(function () {
        _this2.saveMassParamLoader = false;
      });
    }
  },

  computed: {
    ynp: function ynp() {
      if (this.massParam === 'web_enabled') {
        return this.$store.state.decoder.decoders['_dYesNo'];
      } else {
        return this.$store.state.decoder.decoders['_dYesNoPartial'];
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("vQJi")))

/***/ }),

/***/ "3lBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('macrotags-form',{attrs:{"macrotag":_vm.macrotag,"loader":_vm.loader,"showLabels":false},on:{"click":function($event){return _vm.storeMacrotag(_vm.macrotag)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3pgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('collections-form',{attrs:{"collection":_vm.collection,"loader":_vm.loader,"showLabels":false},on:{"click":function($event){return _vm.storeCollection(_vm.collection)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3vTe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_baseModel__ = __webpack_require__("Lb/K");










var Sequence = function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Sequence, _BaseModel);

  function Sequence(create, data) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Sequence);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Sequence.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Sequence)).call(this));

    _this.collections = {};
    _this.description = {
      data: {
        filmPersons: {},
        places: {},
        // keywords: {}
        macrotags: {},
        microtags: {}
      }
    };

    if (create) {
      _this.isNew = true;
    }
    if (data !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });

      _this.durata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters__["a" /* secondsToTime */])(_this.durata);
      _this.end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters__["a" /* secondsToTime */])(_this.end);
      _this.start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters__["a" /* secondsToTime */])(_this.start);
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Sequence, [{
    key: 'prepareForSend',
    value: function prepareForSend() {
      var data = _.cloneDeep(this);
      data.durata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters__["b" /* timeToSeconds */])(data.durata);
      data.end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters__["b" /* timeToSeconds */])(data.end);
      data.start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters__["b" /* timeToSeconds */])(data.start);
      return data;
    }
  }]);

  return Sequence;
}(__WEBPACK_IMPORTED_MODULE_8__models_baseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Sequence);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "49VO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'topbar',
  computed: {
    profile: function profile() {
      return this.$store.state.profile.profile;
    }
  }
});

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4eBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_person__ = __webpack_require__("okgr");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/persons', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/persons/' + id).then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_person__["a" /* default */](response.data.data);
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/persons', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/persons/' + id, data.prepareForSend());
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/persons', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  select: function select(data) {
    var person = new __WEBPACK_IMPORTED_MODULE_2__models_person__["a" /* default */]();
    person.nome = data;
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/persons', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(person),
        limit: 100,
        orderBy: 'nome'
      }
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/persons/' + id);
  }
});

/***/ }),

/***/ "4ryd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_decoder__ = __webpack_require__("MwGy");




var state = {
  decoders: {}
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].SET_DECODERS, function (state, data) {
  state.decoders = data;
});

var actions = {
  getDecoders: function getDecoders(_ref, data) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__api_decoder__["a" /* default */].index().then(function (response) {
      var data = response.data.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].SET_DECODERS, data);
      return response;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "55Ku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_macrotags__ = __webpack_require__("68s8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("Yrvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_macrotag__ = __webpack_require__("/Lmo");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    macrotagsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      macrotag: new __WEBPACK_IMPORTED_MODULE_3__models_macrotag__["a" /* default */](),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuovo macrotag',
      createButton: { display: false }
    });
  },


  methods: {
    storeMacrotag: function storeMacrotag(macrotag) {
      var _this = this;

      this.loader = true;
      macrotag.archive_id = this.$store.state.profile.profile.archive.data.id;
      __WEBPACK_IMPORTED_MODULE_1__api_macrotags__["a" /* default */].store(macrotag).then(function (response) {
        toastr.success('Il macrotag è stato inserito correttamente');
        _this.$router.push('/macrotags');
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "5ANv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ISw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("SLoz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e286e060_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("bn8z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e286e060_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__("GY//");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("zfG0");
function injectStyle (ssrContext) {
  __webpack_require__("vGh4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__("El0Z");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("NuQ6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5zmG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('funds-form',{attrs:{"fund":_vm.fund,"disabled":_vm.disabled,"showLabels":true,"showSave":true},on:{"activate-mod":function($event){return _vm.activateMod()},"save-archive-web":function($event){return _vm.saveArchiveWeb()},"click":function($event){return _vm.updateFund()}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('reels-tab',_vm._b({ref:"reelsTab"},'reels-tab',{requestFunction: _vm.requestFunction},false))],1),_vm._v(" "),(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-md-offset-6 col-sm-3 col-sm-offset-5"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":'/reel'}},[_vm._v("\n                    Nuova bobina\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('div',{staticClass:"input-group col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.massiveReelsInsert),expression:"massiveReelsInsert"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.massiveReelsInsert)},on:{"input":function($event){if($event.target.composing){ return; }_vm.massiveReelsInsert=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reelsMassiveInsert.apply(null, arguments)}}},[_vm._v("Inserimento massivo bobine")])])])])])])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Bobine")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "66Xx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_places__ = __webpack_require__("sWWJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'place', 'loader', 'showLabels'],
  methods: {
    click: function click() {
      this.$emit('click', this.place);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.place);
    }
  },
  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      places: []
    };
  },

  computed: {
    donazione_tipi: function donazione_tipi() {
      return this.$store.state.decoder.decoders['_dDonationTypes'];
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_places__["a" /* default */].index().then(function (response) {
      _this.places = response.data.data;
    });
  },

  components: {}
});

/***/ }),

/***/ "68s8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_macrotag__ = __webpack_require__("/Lmo");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/macrotags?include=microtags', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/macrotags/' + id).then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_macrotag__["a" /* default */](response.data.data);
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/macrotags', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/macrotags/' + id, data.prepareForSend());
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/macrotags', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  select: function select(data) {
    var macrotag = new __WEBPACK_IMPORTED_MODULE_2__models_macrotag__["a" /* default */]();
    macrotag.macrotag = data;
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/macrotags', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(macrotag),
        limit: 100,
        orderBy: 'macrotag'
      }
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/macrotags/' + id);
  }
});

/***/ }),

/***/ "6U8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fineuploader_dropzone__ = __webpack_require__("UNH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fine_uploader_wrappers__ = __webpack_require__("rm6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fine_uploader_wrappers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fine_uploader_wrappers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__ = __webpack_require__("fv+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__("I7CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect_dist_vue_multiselect_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import collectionsApi from '../../api/collections'



// Import this component


// Import date picker css





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'collection', 'loader', 'showLabels'],
  methods: {
    click: function click() {
      this.$emit('click', this.collection);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.collection);
    }
  },
  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      markerUploader: new __WEBPACK_IMPORTED_MODULE_2_fine_uploader_wrappers___default.a({
        options: []
      }),
      imageUploader: new __WEBPACK_IMPORTED_MODULE_2_fine_uploader_wrappers___default.a({
        options: []
      })
    };
  },

  computed: {
    donazione_tipi: function donazione_tipi() {
      return this.$store.state.decoder.decoders['_dDonationTypes'];
    }
  },
  // beforeCreate () {
  //   collectionsApi.index()
  //     .then((response) => {
  //       this.collection = response.data.data
  //     })
  // },
  watch: {
    collection: function collection(val) {
      var _this = this;

      this.markerUploader = new __WEBPACK_IMPORTED_MODULE_2_fine_uploader_wrappers___default.a({
        options: {
          request: {
            endpoint: "https://api.cinescatti.it/v1" + '/collections/' + val.id + '/marker',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'marker'
          },
          callbacks: {
            onComplete: function onComplete(id, name, response) {
              _this.$emit('change-collection-prop', response.data);
            }
          }
        }
      });
      this.imageUploader = new __WEBPACK_IMPORTED_MODULE_2_fine_uploader_wrappers___default.a({
        options: {
          request: {
            endpoint: "https://api.cinescatti.it/v1" + '/collections/' + val.id + '/image',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'image'
          },
          callbacks: {
            onComplete: function onComplete(id, name, response) {
              _this.$emit('change-collection-prop', response.data);
            }
          }
        }
      });
    }
  },
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    dropzone: __WEBPACK_IMPORTED_MODULE_1_vue_fineuploader_dropzone__["a" /* default */]
  }
});

/***/ }),

/***/ "7a9Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7q3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logout',

  mounted: function mounted() {
    this.$store.dispatch('logout');
    this.$router.push('/login');
  }
});

/***/ }),

/***/ "8aDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("WMJC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa57704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("JKHX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa57704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8dO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_collections__ = __webpack_require__("mSmg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionsForm_vue__ = __webpack_require__("mDbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_collection__ = __webpack_require__("wBFF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_funds__ = __webpack_require__("ybAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_sequences__ = __webpack_require__("WBeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_sequence__ = __webpack_require__("3vTe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    collectionsForm: __WEBPACK_IMPORTED_MODULE_2__CollectionsForm_vue__["a" /* default */], Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },

  data: function data() {
    return {
      collection: false,
      disabled: true,
      columns: ['reel_identificativo', 'titolo', 'actions'],
      options: {
        saveState: false,
        headings: {
          'reel_identificativo': 'Identificativo bobina'
        },
        sortable: ['progressivo'],
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_collections__["a" /* default */].sequences(this.$route.params.id, query);
        }
      },
      searchFund: null,
      searchReel: null,
      funds: [],
      reels: [],
      storeSequenceLoader: false
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_collections__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.collection = response;
    });
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Raccolte inserite',
      createButton: {
        display: true,
        text: 'Nuova raccolta',
        to: '/collection'
      }
    });
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updateCollection: function updateCollection(collection) {
      var _this2 = this;

      this.loader = true;
      __WEBPACK_IMPORTED_MODULE_1__api_collections__["a" /* default */].update(this.$route.params.id, collection).then(function (response) {
        toastr.success('La raccolta è stata salvata correttamente');
        _this2.loader = false;
        _this2.disabled = true;
      }).catch(function (response) {
        _this2.loader = false;
      });
    },
    changeCollectionProps: function changeCollectionProps(collection) {
      this.collection = new __WEBPACK_IMPORTED_MODULE_3__models_collection__["a" /* default */](false, collection);
    },
    showSequence: function showSequence(row) {
      this.$router.push({ name: 'sequencesShow', params: { id: row.row.id, showMap: true } });
    },
    detachSequence: function detachSequence(sequence) {
      var _this3 = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_collections__["a" /* default */].detachSequence(this.$route.params.id, sequence).then(function (response) {
          _this3.$refs.sequences.refresh();
          toastr.success('La sequenza è stata correttamente rimossa da questa raccolta');
          _this3.loading = false;
        }).catch(function (response) {
          _this3.loading = false;
        });
      }
    },
    fundsFind: function fundsFind(query) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_funds__["a" /* default */].select(query).then(function (response) {
        _this4.funds = response.data.data;
      });
    },
    searchFundSelected: function searchFundSelected(fund) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_funds__["a" /* default */].reels(fund.id, {
        limit: 10000,
        ascending: 1,
        page: 1,
        byColumn: 0,
        orderBy: 'identificativo'
      }).then(function (resp) {
        _this5.reels = resp.data.data;
      });
    },
    storeSequence: function storeSequence() {
      var _this6 = this;

      this.storeSequenceLoader = true;
      __WEBPACK_IMPORTED_MODULE_7__api_sequences__["a" /* default */].store(new __WEBPACK_IMPORTED_MODULE_8__models_sequence__["a" /* default */](false, { reel_id: this.searchReel.id, collections: { data: [this.collection] } })).then(function (response) {
        toastr.success('La sequenza è stata inserita correttamente');
        _this6.$refs.sequences.refresh();
      }).finally(function (response) {
        _this6.storeSequenceLoader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "8dxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__ = __webpack_require__("jJty");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c80056e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__ = __webpack_require__("ur+n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c80056e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8oLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.place)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.place.nome),expression:"place.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nome","name":"nome","disabled":_vm.disabled},domProps:{"value":(_vm.place.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.place, "nome", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"indirizzo"}},[_vm._v("Indirizzo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.place.indirizzo),expression:"place.indirizzo"}],staticClass:"form-control",attrs:{"type":"text","id":"indirizzo","name":"indirizzo","disabled":_vm.disabled},domProps:{"value":(_vm.place.indirizzo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.place, "indirizzo", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lat"}},[_vm._v("Lat")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.place.lat),expression:"place.lat"}],staticClass:"form-control",attrs:{"type":"text","id":"lat","name":"lat","disabled":_vm.disabled},domProps:{"value":(_vm.place.lat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.place, "lat", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lng"}},[_vm._v("Lng")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.place.lng),expression:"place.lng"}],staticClass:"form-control",attrs:{"type":"text","id":"lng","name":"lng","disabled":_vm.disabled},domProps:{"value":(_vm.place.lng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.place, "lng", $event.target.value)}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block"},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                Salva\n                            ")]):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                                Attiva modifiche\n                            ")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Generali")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9J+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("c5O7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7794ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("K5Af");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7794ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9YrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('v-server-table',{ref:"microtags",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"microtags"},on:{"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading,"row-click":_vm.showMicrotag},scopedSlots:_vm._u([{key:"macrotag",fn:function(props){return [_c('div',[_vm._v("\n                "+_vm._s(props.row.macrotag.data.macrotag)+"\n              ")])]}},{key:"actions",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9tMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.person)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.nome),expression:"person.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nome","name":"nome","disabled":_vm.disabled},domProps:{"value":(_vm.person.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "nome", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"indirizzo"}},[_vm._v("Indirizzo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.indirizzo),expression:"person.indirizzo"}],staticClass:"form-control",attrs:{"type":"text","id":"indirizzo","name":"indirizzo","disabled":_vm.disabled},domProps:{"value":(_vm.person.indirizzo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "indirizzo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cap"}},[_vm._v("Cap")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.cap),expression:"person.cap"}],staticClass:"form-control",attrs:{"type":"text","id":"cap","name":"cap","disabled":_vm.disabled},domProps:{"value":(_vm.person.cap)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "cap", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"provincia"}},[_vm._v("Provincia")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.provincia),expression:"person.provincia"}],staticClass:"form-control",attrs:{"type":"text","id":"provincia","name":"provincia","disabled":_vm.disabled},domProps:{"value":(_vm.person.provincia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "provincia", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"citta"}},[_vm._v("Città")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.citta),expression:"person.citta"}],staticClass:"form-control",attrs:{"type":"text","id":"citta","name":"citta","disabled":_vm.disabled},domProps:{"value":(_vm.person.citta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "citta", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nazionalita"}},[_vm._v("Nazionalità")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.nazionalita),expression:"person.nazionalita"}],staticClass:"form-control",attrs:{"type":"text","id":"nazionalita","name":"nazionalita","disabled":_vm.disabled},domProps:{"value":(_vm.person.nazionalita)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "nazionalita", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.email),expression:"person.email"}],staticClass:"form-control",attrs:{"type":"text","id":"email","name":"email","disabled":_vm.disabled},domProps:{"value":(_vm.person.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"telefono"}},[_vm._v("Telefono")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.telefono),expression:"person.telefono"}],staticClass:"form-control",attrs:{"type":"text","id":"telefono","name":"telefono","disabled":_vm.disabled},domProps:{"value":(_vm.person.telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "telefono", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nascita_data"}},[_vm._v("Data di nascita")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",attrs:{"id":"nascita_data","name":"nascita_data","config":_vm.config,"disabled":_vm.disabled},on:{"dp-error":_vm.error},model:{value:(_vm.person.nascita_data),callback:function ($$v) {_vm.$set(_vm.person, "nascita_data", $$v)},expression:"person.nascita_data"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nascita_citta"}},[_vm._v("Città di nascita")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.nascita_citta),expression:"person.nascita_citta"}],staticClass:"form-control",attrs:{"type":"text","id":"nascita_citta","name":"nascita_citta","disabled":_vm.disabled},domProps:{"value":(_vm.person.nascita_citta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "nascita_citta", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nascita_nazione"}},[_vm._v("Nazione di nascita")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.person.nascita_nazione),expression:"person.nascita_nazione"}],staticClass:"form-control",attrs:{"type":"text","id":"nascita_nazione","name":"nascita_nazione","disabled":_vm.disabled},domProps:{"value":(_vm.person.nascita_nazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.person, "nascita_nazione", $event.target.value)}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block"},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                Salva\n                            ")]):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                                Attiva modifiche\n                            ")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Generali")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9wHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequencesForm_vue__ = __webpack_require__("3GEd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bef3d1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequencesForm_vue__ = __webpack_require__("iZzY");
function injectStyle (ssrContext) {
  __webpack_require__("RODn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bef3d1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequencesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bef3d1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequencesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AG9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Smkt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5393ef40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("9YrY");
function injectStyle (ssrContext) {
  __webpack_require__("AbET")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5393ef40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AbET":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Anal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_macrotags__ = __webpack_require__("68s8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      columns: ['macrotag', 'microtags', 'actions'],
      options: {
        sortable: ['macrotag'],
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_macrotags__["a" /* default */].index(query);
        }
      },
      loading: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Macrotags inseriti',
      createButton: {
        display: true,
        text: 'Nuovo macrotag',
        to: 'macrotag'
      }
    });
  },


  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_macrotags__["a" /* default */].delete(id).then(function (response) {
          _this.$refs.macrotags.refresh();
          toastr.success('La macrotag è stata rimossa correttamente');
          _this.loading = false;
        }).catch(function (response) {
          _this.loading = false;
        });
      }
    },
    toggleLoading: function toggleLoading() {
      // this.loading = !this.loading
    },
    showMacrotags: function showMacrotags(row) {
      this.$router.push({ name: 'macrotagsShow', params: { id: row.row.id } });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "AylU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_persons__ = __webpack_require__("4eBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_reels__ = __webpack_require__("R3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers__ = __webpack_require__("rm6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_fineuploader_dropzone__ = __webpack_require__("UNH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker__ = __webpack_require__("fv+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__("I7CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Description_vue__ = __webpack_require__("au+E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_masked_input__ = __webpack_require__("4q2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_filmformat__ = __webpack_require__("lJgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_filmbrand__ = __webpack_require__("YSSV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Import this component


// Import date picker css











/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'reel', 'loader', 'showLabels', 'showSearch', 'showSave'],
  methods: {
    save: function save() {
      this.reel.fund_id = this.fund.id;
      this.$emit('click', this.reel);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.reel);
    },
    saveArchiveWeb: function saveArchiveWeb() {
      this.$emit('save-archive-web', this.fund);
    },
    search: function search() {
      this.$emit('search', this.fund);
    },
    delImage: function delImage(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_reels__["a" /* default */].deleteImage(this.reel.id, id).then(function (response) {
        _this.reel.reelimages = response.data.data.reelimages;
        toastr.success('L\'immagine è stata rimossa correttamente');
      }).catch(function (response) {});
    },
    delRestorationImage: function delRestorationImage(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_reels__["a" /* default */].deleteRestorationImage(this.reel.restoration.data.id, id).then(function (response) {
        _this2.reel.restoration.data.restorationimages.data = response.data.data.restorationimages.data;
        toastr.success('L\'immagine è stata rimossa correttamente');
      }).catch(function (response) {});
    },
    personsFind: function personsFind(query) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].select(query).then(function (response) {
        _this3.persons = response.data.data;
      });
    }
  },

  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      persons: [],
      formati: [],
      brands: [],
      uploader: new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: []
      }),
      restorationImageUploader: new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: []
      })
    };
  },


  watch: {
    reel: function reel(val) {
      var _this4 = this;

      this.uploader = new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: {
          request: {
            endpoint: "https://api.cinescatti.it/v1" + '/reels/' + val.id + '/reelimage',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'image'
          },
          callbacks: {
            onComplete: function onComplete(id, name, response) {
              _this4.reel.reelimages = response.data.reelimages;
            }
          }
        }
      });

      this.restorationImageUploader = new __WEBPACK_IMPORTED_MODULE_3_fine_uploader_wrappers___default.a({
        options: {
          request: {
            endpoint: "https://api.cinescatti.it/v1" + '/restorations/' + val.restoration.data.id + '/restorationimage',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'image'
          },
          callbacks: {
            onComplete: function onComplete(id, name, response) {
              _this4.reel.restoration.data.restorationimages = response.data.restorationimages;
            }
          }
        }
      });
    }
  },

  computed: {
    formato_tipi: function formato_tipi() {
      return this.$store.state.decoder.decoders['_dReelFormat'];
    },
    freq1: function freq1() {
      return this.$store.state.decoder.decoders['_dFreq1'];
    },
    freq2: function freq2() {
      return this.$store.state.decoder.decoders['_dFreq2'];
    },
    velocity: function velocity() {
      return this.$store.state.decoder.decoders['_dVelocity'];
    },
    filmBrands: function filmBrands() {
      return this.$store.state.decoder.decoders['_dFilmBrand'];
    },
    audio: function audio() {
      return this.$store.state.decoder.decoders['_dAudio'];
    },
    joints: function joints() {
      return this.$store.state.decoder.decoders['_dJoints'];
    },
    fund: function fund() {
      return this.$store.state.ui.actualFund;
    },
    faults: function faults() {
      return this.$store.state.decoder.decoders['_dFaults'];
    },
    cromatismi: function cromatismi() {
      return this.$store.state.decoder.decoders['_dColor'];
    },
    ynp: function ynp() {
      return this.$store.state.decoder.decoders['_dYesNoPartial'];
    },
    shootingStability: function shootingStability() {
      return this.$store.state.decoder.decoders['_dShootingStability'];
    },
    longitudinalNarrowing: function longitudinalNarrowing() {
      return this.$store.state.decoder.decoders['_dLongitudinalNarrowing'];
    }
  },

  beforeCreate: function beforeCreate() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_11__api_filmformat__["a" /* default */].index().then(function (response) {
      _this5.formati = response.data.data;
    });
    __WEBPACK_IMPORTED_MODULE_12__api_filmbrand__["a" /* default */].index().then(function (response) {
      _this5.brands = response.data.data;
    });
  },


  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_5_vue_bootstrap_datetimepicker___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a,
    Description: __WEBPACK_IMPORTED_MODULE_9__components_Description_vue__["a" /* default */],
    Dropzone: __WEBPACK_IMPORTED_MODULE_4_vue_fineuploader_dropzone__["a" /* default */],
    MaskedInput: __WEBPACK_IMPORTED_MODULE_10_vue_masked_input__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "B3kH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C8Nb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('v-server-table',{ref:"persons",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"persons"},on:{"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading,"row-click":_vm.showPerson},scopedSlots:_vm._u([{key:"fondi",fn:function(props){return [_c('div',[_c('ul',_vm._l((props.row.fund.data),function(fund){return _c('li',[_vm._v(_vm._s(fund.denominazione))])}),0)])]}},{key:"actions",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CC2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_keywords__ = __webpack_require__("Rii/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("3foD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_keyword__ = __webpack_require__("+eEl");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    keywordsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      keyword: new __WEBPACK_IMPORTED_MODULE_3__models_keyword__["a" /* default */](),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuova keyword',
      createButton: { display: false }
    });
  },


  methods: {
    storeKeyword: function storeKeyword(keyword) {
      var _this = this;

      this.loader = true;
      keyword.archive_id = this.$store.state.profile.profile.archive.data.id;
      __WEBPACK_IMPORTED_MODULE_1__api_keywords__["a" /* default */].store(keyword).then(function (response) {
        toastr.success('La keyword è stata inserita correttamente');
        _this.$router.push('/keywords');
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "CnVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.isOperator)?_c('div',{staticClass:"text-right",staticStyle:{"margin-bottom":"15px"}},[_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.isRefreshing},on:{"click":_vm.confirmRefreshArchiveWeb}},[_c('i',{staticClass:"fa fa-refresh",class:{ 'fa-spin': _vm.isRefreshing }}),_vm._v("\n                    Aggiorna archivio web\n                ")])]):_vm._e(),_vm._v(" "),_c('funds-tab',_vm._b({ref:"fundsRef",attrs:{"id":"fundsId"}},'funds-tab',{requestFunction: _vm.requestFunction},false))],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__("Pfph");


var _mutations;




var state = {
  access_token: sessionStorage.getItem('access_token'),
  refresh_token: sessionStorage.getItem('refresh_token'),
  expires_in: sessionStorage.getItem('expires_in'),
  isLogged: !!sessionStorage.getItem('isLogged')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].LOGIN_USER, function (state, data) {
  state.access_token = data.access_token;
  state.refresh_token = data.refresh_token;
  state.expires_in = data.expires_in;
  state.isLogged = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].LOGOUT_USER, function (state) {
  state.access_token = null;
  state.refresh_token = null;
  state.expires_in = null;
  state.isLogged = false;
}), _mutations);

var actions = {
  login: function login(_ref, data) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].issueToken(data).then(function (response) {
      var data = response.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].LOGIN_USER, data);
      sessionStorage.setItem('access_token', data.access_token);
      sessionStorage.setItem('refresh_token', data.refresh_token);
      sessionStorage.setItem('expires_in', data.expires_in);
      sessionStorage.setItem('isLogged', true);
      return response;
    });
  },
  refreshToken: function refreshToken(_ref2, data) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].refreshToken(data).then(function (response) {
      var data = response.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].LOGIN_USER, data);
      sessionStorage.setItem('access_token', data.access_token);
      sessionStorage.setItem('refresh_token', data.refresh_token);
      sessionStorage.setItem('expires_in', data.expires_in);
      sessionStorage.setItem('isLogged', true);
      return response;
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].LOGOUT_USER);
    sessionStorage.setItem('access_token', null);
    sessionStorage.setItem('refresh_token', null);
    sessionStorage.setItem('expires_in', null);
    sessionStorage.setItem('isLogged', false);
  }
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "DCGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_keywords__ = __webpack_require__("Rii/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      columns: ['keyword', 'actions'],
      options: {
        sortable: ['keyword'],
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_keywords__["a" /* default */].index(query);
        }
      },
      loading: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Keywords inserite',
      createButton: {
        display: true,
        text: 'Nuova keyword',
        to: 'keyword'
      }
    });
  },


  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_keywords__["a" /* default */].delete(id).then(function (response) {
          _this.$refs.keywords.refresh();
          toastr.success('La keyword è stata rimossa correttamente');
          _this.loading = false;
        }).catch(function (response) {
          _this.loading = false;
        });
      }
    },
    toggleLoading: function toggleLoading() {
      // this.loading = !this.loading
    },
    showKeyword: function showKeyword(row) {
      this.$router.push({ name: 'keywordsShow', params: { id: row.row.id } });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT_USER: 'LOGOUT_USER',

  FILL_PROFILE: 'FILL_PROFILE',

  FILL_FUND: 'FILL_FUND',

  SET_HEADER_STATE: 'SET_HEADER_STATE',

  SET_DECODERS: 'SET_DECODERS',

  SET_ACTUAL_FUND: 'SET_ACTUAL_FUND',
  SET_ACTUAL_REEL: 'SET_ACTUAL_REEL'
});

/***/ }),

/***/ "El0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("WgA/")));

/***/ }),

/***/ "F8Cd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FBz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Esporta selezionati")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('a',{on:{"click":function($event){return _vm.doExport('excel')}}},[_vm._v("Excel")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.doExport('doc')}}},[_vm._v("Doc")])])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-server-table',{ref:"funds",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"funds"},on:{"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading,"row-click":_vm.showFund},scopedSlots:_vm._u([{key:"id",fn:function(props){return [_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox"},domProps:{"value":props.row.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,props.row.id)>-1:(_vm.selected)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=props.row.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}})])]}},{key:"denominazione",fn:function(props){return [_c('div',[_c('strong',[_vm._v(_vm._s(props.row.denominazione))])])]}},{key:"identificativo",fn:function(props){return [_c('div',[_c('strong',[_vm._v(_vm._s(props.row.identificativo))])])]}},{key:"acquisizione_data",fn:function(props){return [_c('div',[_vm._v("\n                    "+_vm._s(_vm._f("dateFormatBase")(props.row.acquisizione_data))+"\n                ")])]}},{key:"acquisizione_tipo",fn:function(props){return [_c('div',[_vm._v("\n                    "+_vm._s(_vm._f("decodeValue")(props.row.acquisizione_tipo,'_dDonationTypes'))+"\n                ")])]}},{key:"formati",fn:function(props){return [_c('ul',_vm._l((props.row.filmFormats.data),function(formato){return _c('li',[_vm._v("\n                        "+_vm._s(formato.name)+"\n                    ")])}),0)]}},{key:"digitalizzazione",fn:function(props){return [_c('div',{staticClass:"text-center"},[(props.row.digitalizzazione === 'sì')?_c('span',{staticClass:"label label-success"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.digitalizzazione === 'parziale')?_c('span',{staticClass:"label label-warning"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.digitalizzazione === 'no')?_c('span',{staticClass:"label label-danger"},[_c('span',{staticClass:"glyphicon glyphicon-remove"})]):_vm._e()])]}},{key:"catalogazione",fn:function(props){return [_c('div',{staticClass:"text-center"},[(props.row.catalogazione === 'sì')?_c('span',{staticClass:"label label-success"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.catalogazione === 'parziale')?_c('span',{staticClass:"label label-warning"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.catalogazione === 'no')?_c('span',{staticClass:"label label-danger"},[_c('span',{staticClass:"glyphicon glyphicon-remove"})]):_vm._e()])]}},{key:"intervista",fn:function(props){return [_c('div',{staticClass:"text-center"},[(props.row.intervista === 1)?_c('span',{staticClass:"label label-success"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.intervista === 2)?_c('span',{staticClass:"label label-warning"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.intervista === 0 || props.row.intervista === null)?_c('span',{staticClass:"label label-danger"},[_c('span',{staticClass:"glyphicon glyphicon-remove"})]):_vm._e()])]}},{key:"updated_at",fn:function(props){return [_c('div',[_vm._v("\n                    "+_vm._s(_vm._f("dateFormatBase")(props.row.updated_at))+"\n                ")])]}},{key:"actions",fn:function(props){return [_c('div',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-expanded":"false"}},[_c('span',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FHMM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__baseModel__ = __webpack_require__("Lb/K");











var anno_inizio_def = 1920;
var anno_fine_def = 1990;

var Fund = function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Fund, _BaseModel);

  function Fund(create, data) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Fund);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Fund.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Fund)).call(this));

    _this.interviewers = {};
    _this.donors = {};
    _this.filmFormats = {};
    _this.fundimages = {};

    if (create) {
      _this.isNew = true;
      _this.range_anni = [anno_inizio_def, anno_fine_def];
      _this.note_generali = _this.emptyNote;
      _this.note_descrizione = _this.emptyNote;
      _this.note_biografiche = _this.emptyNote;
      _this.note_archivista = _this.emptyNote;
      _this.acquisizione_note = _this.emptyNote;
    }
    if (data !== undefined) {
      data.acquisizione_data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["c" /* dpParseDate */])(data.acquisizione_data);
      var anno_inizio = data.anno_inizio !== null ? data.anno_inizio : anno_inizio_def;
      var anno_fine = data.anno_fine !== null ? data.anno_fine : anno_fine_def;
      data.range_anni = [anno_inizio, anno_fine];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Fund, [{
    key: 'prepareForSend',
    value: function prepareForSend() {
      var data = _.cloneDeep(this);
      data.acquisizione_data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["d" /* dateFormatServer */])(data.acquisizione_data);
      data.anno_inizio = data.range_anni[0];
      data.anno_fine = data.range_anni[1];
      return data;
    }
  }, {
    key: 'prepareQueryForSearch',
    value: function prepareQueryForSearch() {
      // this.anno_inizio = (this.range_anni[0] !== anno_inizio_def) ? this.range_anni[0] : null
      // this.anno_fine = (this.range_anni[1] !== anno_fine_def) ? this.range_anni[1] : null
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(Fund.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Fund.prototype), 'prepareQueryForSearch', this).call(this, this);
    }
  }]);

  return Fund;
}(__WEBPACK_IMPORTED_MODULE_9__baseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Fund);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "FaWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropZone",staticClass:"fine-uploader-dropzone-container"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FmBz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GQLb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue__ = __webpack_require__("xgCv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_reels__ = __webpack_require__("R3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_reel__ = __webpack_require__("gQ+i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ReelsTab__ = __webpack_require__("Jqvb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    reelsForm: __WEBPACK_IMPORTED_MODULE_1__Form_vue__["a" /* default */],
    reelsTab: __WEBPACK_IMPORTED_MODULE_4__components_ReelsTab__["a" /* default */]
  },

  data: function data() {
    return {
      reel: new __WEBPACK_IMPORTED_MODULE_3__models_reel__["a" /* default */](false, undefined),
      firstAccess: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('keypress', function (e) {
      if (e.keyCode === 13) {
        _this.$refs.reelsRef.refresh();
        setTimeout(function () {
          _this.$scrollTo('#reelsId');
        }, 100);
      }
    });
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Cerca bobine',
      createButton: { display: false }
    });
    this.$emit('addBackgroundColor', 'rgb(202,94,66)');
  },


  methods: {
    search: function search() {
      this.$refs.reelsRef.refresh();
      this.$scrollTo('#reelsId');
    },
    showReel: function showReel(id) {
      this.$router.push({ name: 'reelsShow', params: { id: id } });
    },

    requestFunction: function requestFunction(query) {
      if (!this.firstAccess) {
        return __WEBPACK_IMPORTED_MODULE_2__api_reels__["a" /* default */].search(this.reel, query);
      }
      this.firstAccess = false;
      return __WEBPACK_IMPORTED_MODULE_2__api_reels__["a" /* default */].search({ 'id': 111111 }, query);
    }
  }
});

/***/ }),

/***/ "GWpP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sequences__ = __webpack_require__("WBeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SequencesForm_vue__ = __webpack_require__("9wHJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_sequence__ = __webpack_require__("3vTe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    sequencesForm: __WEBPACK_IMPORTED_MODULE_2__SequencesForm_vue__["a" /* default */]
  },

  data: function data() {
    return {
      sequence: false,
      reel: false,
      fund: false,
      disabled: true,
      interval: null
    };
  },


  computed: {
    showMap: function showMap() {
      return this.$route.params.showMap;
    }
  },

  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_sequences__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.sequence = response;
      _this.fund = response.fund.data;
      _this.reel = response.reel.data;
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_ACTUAL_REEL, response.reel.data);
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_ACTUAL_FUND, response.fund.data);
    });
    this.$emit('addBackgroundColor', 'rgb(234,186,140)');
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Sequenze inserite',
      createButton: {
        display: false,
        text: 'Nuova sequenza',
        to: '/sequence'
      }
    });
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_sequences__["a" /* default */].update(_this2.$route.params.id, _this2.sequence);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updateSequence: function updateSequence() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_sequences__["a" /* default */].update(this.$route.params.id, this.sequence).then(function (response) {
        toastr.success('La sequenza è stata salvata correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    },
    prev: function prev() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_sequences__["a" /* default */].prev(this.sequence.id).then(function (response) {
        _this4.$router.push({ name: 'sequencesShow', params: { id: response.data } });
      });
    },
    next: function next() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_sequences__["a" /* default */].next(this.sequence.id).then(function (response) {
        _this5.$router.push({ name: 'sequencesShow', params: { id: response.data } });
      });
    },
    updateSequenceProp: function updateSequenceProp(sequence) {
      this.sequence = new __WEBPACK_IMPORTED_MODULE_3__models_sequence__["a" /* default */](false, sequence);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "GY//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hOwk")));

/***/ }),

/***/ "GnNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_collections__ = __webpack_require__("mSmg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionsForm_vue__ = __webpack_require__("mDbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_collection__ = __webpack_require__("wBFF");
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    collectionsForm: __WEBPACK_IMPORTED_MODULE_2__CollectionsForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      collection: new __WEBPACK_IMPORTED_MODULE_3__models_collection__["a" /* default */](),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuova raccolta',
      createButton: { display: false }
    });
  },


  methods: {
    storeCollection: function storeCollection(collection) {
      var _this = this;

      this.loader = true;
      __WEBPACK_IMPORTED_MODULE_1__api_collections__["a" /* default */].store(collection).then(function (response) {
        toastr.success('La raccolta è stata inserita correttamente');
        _this.$router.push('/collections/' + response.data.data.id);
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "Go0g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I+lN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Suwn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc4567e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("l/6N");
function injectStyle (ssrContext) {
  __webpack_require__("XikV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc4567e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I7CV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ITCS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequencesCreate_vue__ = __webpack_require__("fV1i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f36b464e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequencesCreate_vue__ = __webpack_require__("nUgo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequencesCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f36b464e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequencesCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IToN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IVEa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_profile__ = __webpack_require__("PMOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ui__ = __webpack_require__("XZap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_decoder__ = __webpack_require__("4ryd");


// import * as getters from './getters'
// import * as actions from './actions'





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: debug,
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_3__modules_profile__["a" /* default */],
    ui: __WEBPACK_IMPORTED_MODULE_4__modules_ui__["a" /* default */],
    decoder: __WEBPACK_IMPORTED_MODULE_5__modules_decoder__["a" /* default */]
  }
}));

/***/ }),

/***/ "IjMb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ivuc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JKHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('reels-form',{attrs:{"reel":_vm.reel,"loader":_vm.loader,"showLabels":false,"showSave":true},on:{"click":function($event){return _vm.storeReel(_vm.reel)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jqvb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReelsTab_vue__ = __webpack_require__("3gx8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e6823b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReelsTab_vue__ = __webpack_require__("u3pw");
function injectStyle (ssrContext) {
  __webpack_require__("FmBz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60e6823b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReelsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e6823b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReelsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K5Af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('funds-form',{attrs:{"fund":_vm.fund,"loader":_vm.loader,"showLabels":false,"showSave":true},on:{"click":function($event){return _vm.storeFund(_vm.fund)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K6Za":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_persons__ = __webpack_require__("4eBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("hqyI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_person__ = __webpack_require__("okgr");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    personsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      person: new __WEBPACK_IMPORTED_MODULE_3__models_person__["a" /* default */](),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuova persona',
      createButton: { display: false }
    });
  },


  methods: {
    storePerson: function storePerson(person) {
      var _this = this;

      this.loader = true;
      person.archive_id = this.$store.state.profile.profile.archive.data.id;
      __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].store(person).then(function (response) {
        toastr.success('La persona è stata inserita correttamente');
        _this.$router.push('/persons');
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "KxUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("CC2g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39105a68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("Ly/R");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39105a68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lb/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var BaseModel = function () {
  function BaseModel() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BaseModel);

    this.emptyNote = '/';
    this.isNew = false;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BaseModel, [{
    key: 'prepareQueryForSearch',
    value: function prepareQueryForSearch(model) {
      var params = {
        limit: 100
      };

      var _loop = function _loop(property) {
        if (model.hasOwnProperty(property)) {
          if (model[property] instanceof Object) {
            if (model[property].data !== undefined) {
              if (model[property].data.length > 0) {
                params[property + '-id'] = [];
                model[property].data.forEach(function (value) {
                  params[property + '-id'].push(value.id);
                });
              }
            }
          } else {
            if (model[property] !== '') {
              params[property] = model[property];
            }
          }
        }
      };

      for (var property in model) {
        _loop(property);
      }

      return params;
    }
  }]);

  return BaseModel;
}();

/* harmony default export */ __webpack_exports__["a"] = (BaseModel);

/***/ }),

/***/ "LdPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collection)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Titolo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.collection.title),expression:"collection.title"}],staticClass:"form-control",attrs:{"type":"text","id":"title","name":"title","disabled":_vm.disabled},domProps:{"value":(_vm.collection.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.collection, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"description"}},[_vm._v("Descrizione")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.collection.description),expression:"collection.description"}],staticClass:"form-control",attrs:{"id":"description","name":"description","disabled":_vm.disabled},domProps:{"value":(_vm.collection.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.collection, "description", $event.target.value)}}})])])]),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('span',{staticClass:"text-bold"},[_vm._v("Marker")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.collection.marker),expression:"collection.marker"}],staticClass:"img-responsive collection-marker",attrs:{"src":_vm.collection.marker}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"col-md-6"},[_c('span',{staticClass:"text-bold"},[_vm._v("Trascina qui il nuovo marker")]),_vm._v(" "),_c('dropzone',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],style:({ border: '2px dashed', height: '200px', width: '100%' }),attrs:{"uploader":_vm.markerUploader}})],1)]):_vm._e(),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('span',{staticClass:"text-bold"},[_vm._v("Immagine")]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.collection.image),expression:"collection.image"}],staticClass:"img-responsive collection-marker",attrs:{"src":_vm.collection.image}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"col-md-6"},[_c('span',{staticClass:"text-bold"},[_vm._v("Trascina qui la nuova immagine")]),_vm._v(" "),_c('dropzone',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],style:({ border: '2px dashed', height: '200px', width: '100%' }),attrs:{"uploader":_vm.imageUploader}})],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Pubblicato")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.collection.published),expression:"collection.published"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.collection.published)?_vm._i(_vm.collection.published,null)>-1:(_vm.collection.published)},on:{"change":function($event){var $$a=_vm.collection.published,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.collection, "published", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.collection, "published", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.collection, "published", $$c)}}}})])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block"},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                Salva\n              ")]):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                Attiva modifiche\n              ")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Generali")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LwKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_places__ = __webpack_require__("sWWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("YO57");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_place__ = __webpack_require__("oXUi");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    placesForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      place: new __WEBPACK_IMPORTED_MODULE_3__models_place__["a" /* default */](),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuovo luogo',
      createButton: { display: false }
    });
  },


  methods: {
    storePlace: function storePlace(place) {
      var _this = this;

      this.loader = true;
      place.archive_id = this.$store.state.profile.profile.archive.data.id;
      __WEBPACK_IMPORTED_MODULE_1__api_places__["a" /* default */].store(place).then(function (response) {
        toastr.success('Il luogo è stato inserito correttamente');
        _this.$router.push('/places');
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "Ly/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('keywords-form',{attrs:{"keyword":_vm.keyword,"loader":_vm.loader,"showLabels":false},on:{"click":function($event){return _vm.storeKeyword(_vm.keyword)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M04B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_persons__ = __webpack_require__("4eBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__ = __webpack_require__("fv+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__("I7CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Import this component


// Import date picker css





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'person', 'loader', 'showLabels'],
  methods: {
    click: function click() {
      this.$emit('click', this.person);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.person);
    }
  },
  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      persons: []
    };
  },

  computed: {
    donazione_tipi: function donazione_tipi() {
      return this.$store.state.decoder.decoders['_dDonationTypes'];
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].index().then(function (response) {
      _this.persons = response.data.data;
    });
  },

  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  }
});

/***/ }),

/***/ "M71J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("w54t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444e0712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("TWpG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444e0712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660767b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("2gHw");
function injectStyle (ssrContext) {
  __webpack_require__("09nQ")
  __webpack_require__("F8Cd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660767b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MMjd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"anno_inizio"}},[_vm._v("Anno inizio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.anno_inizio),expression:"description.anno_inizio"}],staticClass:"form-control",attrs:{"type":"text","id":"anno_inizio","name":"anno_inizio","disabled":_vm.disabled},domProps:{"value":(_vm.description.anno_inizio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.description, "anno_inizio", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"anno_fine"}},[_vm._v("Anno fine")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.anno_fine),expression:"description.anno_fine"}],staticClass:"form-control",attrs:{"type":"text","id":"anno_fine","name":"anno_fine","disabled":_vm.disabled},domProps:{"value":(_vm.description.anno_fine)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.description, "anno_fine", $event.target.value)}}})])])]),_vm._v(" "),(!_vm.reelDescription)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"suono"}},[_vm._v("Suono")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.suono),expression:"description.suono"}],staticClass:"form-control",attrs:{"id":"suono","name":"suono","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.description, "suono", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.suoni),function(suono,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n            "+_vm._s(suono)+"\n          ")])})],2)])])]):_vm._e(),_vm._v(" "),(_vm.reelDescription)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"suono"}},[_vm._v("Suono")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.suono),expression:"description.suono"}],staticClass:"form-control",attrs:{"id":"reel-suono","name":"suono","disabled":true},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.description, "suono", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(suono,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n            "+_vm._s(suono)+"\n          ")])})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cromatismo"}},[_vm._v("Cromatismo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.cromatismo),expression:"description.cromatismo"}],staticClass:"form-control",attrs:{"id":"cromatismo","name":"cromatismo","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.description, "cromatismo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.cromatismi),function(cromatismo,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n            "+_vm._s(cromatismo)+"\n          ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipologia")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.tipo_famiglia),expression:"description.tipo_famiglia"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.description.tipo_famiglia)?_vm._i(_vm.description.tipo_famiglia,null)>-1:(_vm.description.tipo_famiglia)},on:{"change":function($event){var $$a=_vm.description.tipo_famiglia,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.description, "tipo_famiglia", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.description, "tipo_famiglia", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.description, "tipo_famiglia", $$c)}}}}),_vm._v("\n            Famiglia\n          ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.tipo_amatoriale),expression:"description.tipo_amatoriale"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.description.tipo_amatoriale)?_vm._i(_vm.description.tipo_amatoriale,null)>-1:(_vm.description.tipo_amatoriale)},on:{"change":function($event){var $$a=_vm.description.tipo_amatoriale,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.description, "tipo_amatoriale", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.description, "tipo_amatoriale", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.description, "tipo_amatoriale", $$c)}}}}),_vm._v("\n            Amatoriale\n          ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description.tipo_edizione),expression:"description.tipo_edizione"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.description.tipo_edizione)?_vm._i(_vm.description.tipo_edizione,null)>-1:(_vm.description.tipo_edizione)},on:{"change":function($event){var $$a=_vm.description.tipo_edizione,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.description, "tipo_edizione", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.description, "tipo_edizione", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.description, "tipo_edizione", $$c)}}}}),_vm._v("\n            Di edizione\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"filmPersons"}},[_vm._v("Persone")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.persons,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"filmPersons","name":"filmPersons","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.personsFind},model:{value:(_vm.description.filmPersons.data),callback:function ($$v) {_vm.$set(_vm.description.filmPersons, "data", $$v)},expression:"description.filmPersons.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"macrotags"}},[_vm._v("Macrotags")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.macrotags,"multiple":true,"track-by":"id","label":"macrotag","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"macrotags","name":"macrotags","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.macrotagsFind},model:{value:(_vm.description.macrotags.data),callback:function ($$v) {_vm.$set(_vm.description.macrotags, "data", $$v)},expression:"description.macrotags.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"microtags"}},[_vm._v("Microtags")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.microtags,"multiple":true,"track-by":"id","label":"microtag","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"microtags","name":"microtags","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.microtagsFind},model:{value:(_vm.description.microtags.data),callback:function ($$v) {_vm.$set(_vm.description.microtags, "data", $$v)},expression:"description.microtags.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"places"}},[_vm._v("Luoghi")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.places,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"places","name":"places","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.placesFind},model:{value:(_vm.description.places.data),callback:function ($$v) {_vm.$set(_vm.description.places, "data", $$v)},expression:"description.places.data"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MjDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DCGV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac05b1fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("nkGx");
function injectStyle (ssrContext) {
  __webpack_require__("IVEa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac05b1fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mplq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("crw2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2f92a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("iJOI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b2f92a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MwGy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__("rMyF");


/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index() {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/decoders');
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill__ = __webpack_require__("u7Vc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_js_bootstrap__ = __webpack_require__("K3J8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_js_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_js_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_admin_lte_dist_js_adminlte__ = __webpack_require__("sjfR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_admin_lte_dist_js_adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_admin_lte_dist_js_adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_fonts_fontawesome_webfont_eot__ = __webpack_require__("cmUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_fonts_fontawesome_webfont_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_font_awesome_fonts_fontawesome_webfont_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_fonts_fontawesome_webfont_svg__ = __webpack_require__("P8RI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_fonts_fontawesome_webfont_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_fonts_fontawesome_webfont_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_font_awesome_fonts_fontawesome_webfont_ttf__ = __webpack_require__("bh45");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_font_awesome_fonts_fontawesome_webfont_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_font_awesome_fonts_fontawesome_webfont_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_font_awesome_fonts_fontawesome_webfont_woff__ = __webpack_require__("zXzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_font_awesome_fonts_fontawesome_webfont_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_font_awesome_fonts_fontawesome_webfont_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_fonts_fontawesome_webfont_woff2__ = __webpack_require__("W9/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_fonts_fontawesome_webfont_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_font_awesome_fonts_fontawesome_webfont_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__node_modules_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__node_modules_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__node_modules_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__node_modules_admin_lte_dist_css_AdminLTE_css__ = __webpack_require__("r+qt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__node_modules_admin_lte_dist_css_AdminLTE_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__node_modules_admin_lte_dist_css_AdminLTE_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__node_modules_admin_lte_dist_css_skins_skin_blue_css__ = __webpack_require__("IjMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__node_modules_admin_lte_dist_css_skins_skin_blue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__node_modules_admin_lte_dist_css_skins_skin_blue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__node_modules_font_awesome_css_font_awesome_css__ = __webpack_require__("5W1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__node_modules_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__node_modules_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__node_modules_toastr_build_toastr_css__ = __webpack_require__("IToN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__node_modules_toastr_build_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__node_modules_toastr_build_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scss_app_scss__ = __webpack_require__("Vp6e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__scss_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_tables_2__ = __webpack_require__("e9ss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config_vuetables__ = __webpack_require__("Xs64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_AccessControl__ = __webpack_require__("PFPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__bugsnag_js__ = __webpack_require__("WdoM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__bugsnag_plugin_vue__ = __webpack_require__("KIXd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__bugsnag_plugin_vue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Bugsnag from 'bugsnag-js'
// Bugsnag.apiKey = 'a7dc866e4a6a2a44f3a9fce3412429a8'











































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_tables_2__["ServerTable"], __WEBPACK_IMPORTED_MODULE_21__config_vuetables__["a" /* default */], true);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue_scrollto___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue2_google_maps__, {
  load: {
    key: 'AIzaSyAnDTefg8pqKnl6_k4LI4KlTr3lW4IixwE',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // // If you want to set the version, you can do so:
    // v: '3.26',


    // // If you intend to programmatically custom event listener code
    // // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    // // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    // // you might need to turn this on.
    // autobindAllEvents: false,

    // // If you want to manually install components, e.g.
    // // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    // // Vue.component('GmapMarker', GmapMarker)
    // // then disable the following:
    // installComponents: true,

  } });

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$accessControl = __WEBPACK_IMPORTED_MODULE_24__helpers_AccessControl__["a" /* default */];

if (false) {
  Bugsnag.start({
    apiKey: process.env.BUGSNAG_KEY,
    plugins: [new BugsnagPluginVue()]
  });
  var bugsnagVue = Bugsnag.getPlugin('vue');
  bugsnagVue.installVueErrorHandler(Vue);
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */] }
});

/***/ }),

/***/ "NuQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OA/g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OAGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("K6Za");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c1dfb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("yXK1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c1dfb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oa1L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Anal");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c1b386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("UhX2");
function injectStyle (ssrContext) {
  __webpack_require__("/cB2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c1b386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P8RI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "PFPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isOperator: function isOperator(profile) {
    return profile.roles !== undefined && profile.roles.filter(function (role) {
      return role === 'operator';
    }).length > 0;
  }
});

/***/ }),

/***/ "PMOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_profile__ = __webpack_require__("V/Yq");




var state = {
  profile: {}
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].FILL_PROFILE, function (state, data) {
  state.profile = data;
});

var actions = {
  fillProfile: function fillProfile(_ref, data) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__api_profile__["a" /* default */].get().then(function (response) {
      var data = response.data.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].FILL_PROFILE, data);
      return response;
    });
  },
  updateProfile: function updateProfile(_ref2, data) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_2__api_profile__["a" /* default */].update(data).then(function (response) {
      var data = response.data.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].FILL_PROFILE, data);
      return response;
    });
  },
  password: function password(ctx, data) {
    return __WEBPACK_IMPORTED_MODULE_2__api_profile__["a" /* default */].password(data);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Pfph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__("rMyF");


/* harmony default export */ __webpack_exports__["a"] = ({
  issueToken: function issueToken(data) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].post('/token', {
      grant_type: 'password',
      client_id: 1,
      client_secret: "jfqwtxZQCSyrC7XtwlidhzVXGpqok5FEkkeBvTeh",
      username: data.username,
      password: data.password,
      scope: ''
    });
  },
  refreshToken: function refreshToken(data) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].post('/token', {
      grant_type: 'refresh_token',
      client_id: 1,
      client_secret: "jfqwtxZQCSyrC7XtwlidhzVXGpqok5FEkkeBvTeh",
      refresh_token: data.refresh_token,
      scope: ''
    });
  }
});

/***/ }),

/***/ "PkyL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q/lz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("fP+C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cad3eb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("C8Nb");
function injectStyle (ssrContext) {
  __webpack_require__("PkyL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cad3eb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R3Pa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_reel__ = __webpack_require__("gQ+i");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/reels', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/reels/' + id + '?include=fund').then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_reel__["a" /* default */](false, response.data.data);
    });
  },
  prev: function prev(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/reels/' + id + '/prev?include=fund');
  },
  next: function next(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/reels/' + id + '/next?include=fund');
  },
  sequences: function sequences(id, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/reels/' + id + '/sequences', {
      params: query
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/reels', data.prepareForSend());
  },
  storeMassive: function storeMassive(reel) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/reels-store-massive', reel.prepareForSend());
  },
  updateMassive: function updateMassive(massParam, massValue, massSelected) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/reels-update-massive', {
      massParam: massParam,
      massValue: massValue,
      massSelected: massSelected
    });
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/reels/' + id, data.prepareForSend());
  },
  saveArchiveWeb: function saveArchiveWeb(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/reels-save-archive-web/' + id);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/reels/' + id);
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/reels', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        include: 'fund',
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  deleteImage: function deleteImage(reelId, imageId) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/reels/' + reelId + '/reelimage/' + imageId);
  },
  deleteRestorationImage: function deleteRestorationImage(restorationId, imageId) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/restorations/' + restorationId + '/restorationimage/' + imageId);
  }
});

/***/ }),

/***/ "RODn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rii/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_keyword__ = __webpack_require__("+eEl");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/keywords', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/keywords/' + id).then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_keyword__["a" /* default */](response.data.data);
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/keywords', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/keywords/' + id, data.prepareForSend());
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/keywords', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  select: function select(data) {
    var keyword = new __WEBPACK_IMPORTED_MODULE_2__models_keyword__["a" /* default */]();
    keyword.keyword = data;
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/keywords', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(keyword),
        limit: 100,
        orderBy: 'keyword'
      }
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/keywords/' + id);
  }
});

/***/ }),

/***/ "S+XY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reel)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSave),expression:"showSave"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                            Salva\n                        ")]):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                            Attiva modifiche\n                        ")]):_vm._e()]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                            Cerca\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"titolo_originale"}},[_vm._v("Titolo proprio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.titolo_originale),expression:"reel.titolo_originale"}],staticClass:"form-control",attrs:{"type":"text","id":"titolo_originale","name":"titolo_originale","disabled":_vm.disabled},domProps:{"value":(_vm.reel.titolo_originale)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel, "titolo_originale", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"titolo_attribuito"}},[_vm._v("Titolo attribuito")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.titolo_attribuito),expression:"reel.titolo_attribuito"}],staticClass:"form-control",attrs:{"type":"text","id":"titolo_attribuito","name":"titolo_attribuito","disabled":_vm.disabled},domProps:{"value":(_vm.reel.titolo_attribuito)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel, "titolo_attribuito", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"anno_inizio"}},[_vm._v("Anno inizio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.anno_inizio),expression:"reel.description.data.anno_inizio"}],staticClass:"form-control",attrs:{"type":"text","id":"anno_inizio","name":"anno_inizio","disabled":_vm.disabled},domProps:{"value":(_vm.reel.description.data.anno_inizio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.description.data, "anno_inizio", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Data attribuita")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.anno_inizio_attribuito),expression:"reel.description.data.anno_inizio_attribuito"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.reel.description.data.anno_inizio_attribuito)?_vm._i(_vm.reel.description.data.anno_inizio_attribuito,null)>-1:(_vm.reel.description.data.anno_inizio_attribuito)},on:{"change":function($event){var $$a=_vm.reel.description.data.anno_inizio_attribuito,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.reel.description.data, "anno_inizio_attribuito", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.reel.description.data, "anno_inizio_attribuito", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.reel.description.data, "anno_inizio_attribuito", $$c)}}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"anno_fine"}},[_vm._v("Anno fine")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.anno_fine),expression:"reel.description.data.anno_fine"}],staticClass:"form-control",attrs:{"type":"text","id":"anno_fine","name":"anno_fine","disabled":_vm.disabled},domProps:{"value":(_vm.reel.description.data.anno_fine)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.description.data, "anno_fine", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Data attribuita")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.anno_fine_attribuito),expression:"reel.description.data.anno_fine_attribuito"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.reel.description.data.anno_fine_attribuito)?_vm._i(_vm.reel.description.data.anno_fine_attribuito,null)>-1:(_vm.reel.description.data.anno_fine_attribuito)},on:{"change":function($event){var $$a=_vm.reel.description.data.anno_fine_attribuito,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.reel.description.data, "anno_fine_attribuito", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.reel.description.data, "anno_fine_attribuito", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.reel.description.data, "anno_fine_attribuito", $$c)}}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"filmFormats"}},[_vm._v("Formato/i")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.formati,"multiple":true,"track-by":"id","label":"name","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"filmFormats","name":"filmFormats","disabled":_vm.disabled},model:{value:(_vm.reel.filmFormats.data),callback:function ($$v) {_vm.$set(_vm.reel.filmFormats, "data", $$v)},expression:"reel.filmFormats.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"suono"}},[_vm._v("Suono")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.suono),expression:"reel.description.data.suono"}],staticClass:"form-control",attrs:{"id":"suono","name":"suono","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.description.data, "suono", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(suono,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(suono)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cromatismo"}},[_vm._v("Cromatismo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.cromatismo),expression:"reel.description.data.cromatismo"}],staticClass:"form-control",attrs:{"id":"cromatismo","name":"cromatismo","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.description.data, "cromatismo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.cromatismi),function(cromatismo,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(cromatismo)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"durata"}},[_vm._v("Durata totale bobina (h/m/s)")]),_vm._v(" "),_c('masked-input',{staticClass:"form-control",attrs:{"mask":"11:11:11","placeholder":"00:00:00","id":"durata","name":"durata","disabled":_vm.disabled},model:{value:(_vm.reel.durata),callback:function ($$v) {_vm.$set(_vm.reel, "durata", $$v)},expression:"reel.durata"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lunghezza"}},[_vm._v("Lunghezza")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.lunghezza),expression:"reel.lunghezza"}],staticClass:"form-control",attrs:{"type":"text","id":"lunghezza","name":"lunghezza","disabled":_vm.disabled},domProps:{"value":(_vm.reel.lunghezza)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel, "lunghezza", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipologia")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.tipo_famiglia),expression:"reel.description.data.tipo_famiglia"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.reel.description.data.tipo_famiglia)?_vm._i(_vm.reel.description.data.tipo_famiglia,null)>-1:(_vm.reel.description.data.tipo_famiglia)},on:{"change":function($event){var $$a=_vm.reel.description.data.tipo_famiglia,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.reel.description.data, "tipo_famiglia", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.reel.description.data, "tipo_famiglia", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.reel.description.data, "tipo_famiglia", $$c)}}}}),_vm._v("\n                                                    Famiglia\n                                                ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.tipo_amatoriale),expression:"reel.description.data.tipo_amatoriale"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.reel.description.data.tipo_amatoriale)?_vm._i(_vm.reel.description.data.tipo_amatoriale,null)>-1:(_vm.reel.description.data.tipo_amatoriale)},on:{"change":function($event){var $$a=_vm.reel.description.data.tipo_amatoriale,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.reel.description.data, "tipo_amatoriale", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.reel.description.data, "tipo_amatoriale", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.reel.description.data, "tipo_amatoriale", $$c)}}}}),_vm._v("\n                                                    Amatoriale\n                                                ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.description.data.tipo_edizione),expression:"reel.description.data.tipo_edizione"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.reel.description.data.tipo_edizione)?_vm._i(_vm.reel.description.data.tipo_edizione,null)>-1:(_vm.reel.description.data.tipo_edizione)},on:{"change":function($event){var $$a=_vm.reel.description.data.tipo_edizione,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.reel.description.data, "tipo_edizione", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.reel.description.data, "tipo_edizione", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.reel.description.data, "tipo_edizione", $$c)}}}}),_vm._v("\n                                                    Edizione\n                                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"file_master_dimensione"}},[_vm._v("Dimensione file master")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.file_master_dimensione),expression:"reel.file_master_dimensione"}],staticClass:"form-control",attrs:{"type":"text","id":"file_master_dimensione","name":"file_master_dimensione","disabled":_vm.disabled},domProps:{"value":(_vm.reel.file_master_dimensione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel, "file_master_dimensione", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"file_copia_dimensione"}},[_vm._v("Dimensione file copia")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.file_copia_dimensione),expression:"reel.file_copia_dimensione"}],staticClass:"form-control",attrs:{"type":"text","id":"file_copia_dimensione","name":"file_copia_dimensione","disabled":_vm.disabled},domProps:{"value":(_vm.reel.file_copia_dimensione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel, "file_copia_dimensione", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note_r"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.note),expression:"reel.note"}],staticClass:"form-control",attrs:{"id":"note_r","name":"note_r","disabled":_vm.disabled},domProps:{"value":(_vm.reel.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel, "note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"catalogato"}},[_vm._v("Catalogato?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.catalogato),expression:"reel.catalogato"}],staticClass:"form-control",attrs:{"id":"catalogato","name":"catalogato","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel, "catalogato", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])])]),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ul',{attrs:{"id":"gallery"}},_vm._l((_vm.reel.reelimages.data),function(image){return _c('li',[_c('a',{attrs:{"href":image.url,"target":"_blank"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":image.url}})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"btn btn-xs btn-danger",on:{"click":function($event){$event.preventDefault();return _vm.delImage(image.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dropzone',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],style:({ border: '2px dashed', height: '200px', width: '100%' }),attrs:{"uploader":_vm.uploader}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"text-bold"},[_vm._v("Trascina qui i file da caricare")])],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_4"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('description',{attrs:{"description":_vm.reel.description.data,"disabled":_vm.disabled,"reel-description":true}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"abstract"}},[_vm._v("Descrizione contenuto bobina")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.abstract),expression:"reel.abstract"}],staticClass:"form-control",attrs:{"id":"abstract","name":"abstract","disabled":_vm.disabled},domProps:{"value":(_vm.reel.abstract)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel, "abstract", $event.target.value)}}})])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_2"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"filmBrands"}},[_vm._v("Marca pellicola")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.brands,"multiple":true,"track-by":"id","label":"name","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"filmBrands","name":"filmBrands","disabled":_vm.disabled},model:{value:(_vm.reel.filmBrands.data),callback:function ($$v) {_vm.$set(_vm.reel.filmBrands, "data", $$v)},expression:"reel.filmBrands.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"audio"}},[_vm._v("Pista sonora")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.audio),expression:"reel.restoration.data.audio"}],staticClass:"form-control",attrs:{"id":"audio","name":"audio","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.restoration.data, "audio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.audio),function(a,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(a)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"audio_note_d"}},[_vm._v("Note pista sonora")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.audio_note),expression:"reel.restoration.data.audio_note"}],staticClass:"form-control",attrs:{"id":"audio_note_d","name":"audio_note_d","disabled":_vm.disabled},domProps:{"value":(_vm.reel.restoration.data.audio_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.restoration.data, "audio_note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sindrome_aceto"}},[_vm._v("Sindrome dell'aceto")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.sindrome_aceto),expression:"reel.restoration.data.sindrome_aceto"}],staticClass:"form-control",attrs:{"id":"sindrome_aceto","name":"sindrome_aceto","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.restoration.data, "sindrome_aceto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"colore_decaduto"}},[_vm._v("Decadimento colore")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.colore_decaduto),expression:"reel.restoration.data.colore_decaduto"}],staticClass:"form-control",attrs:{"id":"colore_decaduto","name":"colore_decaduto","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.restoration.data, "colore_decaduto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sporco"}},[_vm._v("Polvere/sporco")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.sporco),expression:"reel.restoration.data.sporco"}],staticClass:"form-control",attrs:{"id":"sporco","name":"sporco","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.restoration.data, "sporco", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"tipologia_giunte"}},[_vm._v("Tipologia giunte")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.tipologia_giunte),expression:"reel.restoration.data.tipologia_giunte"}],staticClass:"form-control",attrs:{"id":"tipologia_giunte","name":"tipologia_giunte","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.restoration.data, "tipologia_giunte", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.joints),function(joint,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(joint)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"restringimento"}},[_vm._v("Restringimento longitudinale")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.restringimento),expression:"reel.digitazion.data.restringimento"}],staticClass:"form-control",attrs:{"id":"restringimento","name":"restringimento","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.digitazion.data, "restringimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.longitudinalNarrowing),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.note),expression:"reel.restoration.data.note"}],staticClass:"form-control",attrs:{"id":"note","name":"note","disabled":_vm.disabled},domProps:{"value":(_vm.reel.restoration.data.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.restoration.data, "note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"info_scatola"}},[_vm._v("Informazioni contenitore originale")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.info_scatola),expression:"reel.restoration.data.info_scatola"}],staticClass:"form-control",attrs:{"id":"info_scatola","name":"info_scatola","disabled":_vm.disabled},domProps:{"value":(_vm.reel.restoration.data.info_scatola)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.restoration.data, "info_scatola", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"restorers"}},[_vm._v("Operatore/i")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.persons,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"filmAnalyzers","name":"filmAnalyzers","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.personsFind},model:{value:(_vm.reel.restoration.data.filmAnalyzers.data),callback:function ($$v) {_vm.$set(_vm.reel.restoration.data.filmAnalyzers, "data", $$v)},expression:"reel.restoration.data.filmAnalyzers.data"}})],1)])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Restauro eseguito?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restauro),expression:"reel.restauro"}],staticClass:"form-control",attrs:{"id":"restauro","name":"restauro","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel, "restauro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"data_rest"}},[_vm._v("Data primo intervento")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",attrs:{"id":"data_rest","name":"data_digit","config":_vm.config,"disabled":_vm.disabled},on:{"dp-error":_vm.error},model:{value:(_vm.reel.restoration.data.data),callback:function ($$v) {_vm.$set(_vm.reel.restoration.data, "data", $$v)},expression:"reel.restoration.data.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"ult_rev_data"}},[_vm._v("Data ulteriori interventi")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",attrs:{"id":"ult_rev_data","name":"data_digit","config":_vm.config,"disabled":_vm.disabled},on:{"dp-error":_vm.error},model:{value:(_vm.reel.restoration.data.ult_rev_data),callback:function ($$v) {_vm.$set(_vm.reel.restoration.data, "ult_rev_data", $$v)},expression:"reel.restoration.data.ult_rev_data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"pulizia"}},[_vm._v("Pulizia pellicola effettuata")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.pulizia),expression:"reel.restoration.data.pulizia"}],staticClass:"form-control",attrs:{"id":"pulizia","name":"pulizia","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.restoration.data, "pulizia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"giunte_ripristinate"}},[_vm._v("Giunte ripristinate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.giunte_ripristinate),expression:"reel.restoration.data.giunte_ripristinate"}],staticClass:"form-control",attrs:{"type":"text","id":"giunte_ripristinate","name":"giunte_ripristinate","disabled":_vm.disabled},domProps:{"value":(_vm.reel.restoration.data.giunte_ripristinate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.restoration.data, "giunte_ripristinate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"fotogrammi_rimossi"}},[_vm._v("Fotogrammi rimossi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.fotogrammi_rimossi),expression:"reel.restoration.data.fotogrammi_rimossi"}],staticClass:"form-control",attrs:{"type":"text","id":"fotogrammi_rimossi","name":"fotogrammi_rimossi","disabled":_vm.disabled},domProps:{"value":(_vm.reel.restoration.data.fotogrammi_rimossi)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.restoration.data, "fotogrammi_rimossi", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"interventi_note"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.restoration.data.interventi_note),expression:"reel.restoration.data.interventi_note"}],staticClass:"form-control",attrs:{"id":"interventi_note","name":"interventi_note","disabled":_vm.disabled},domProps:{"value":(_vm.reel.restoration.data.interventi_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.restoration.data, "interventi_note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"restorers"}},[_vm._v("Operatore/i")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.persons,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"restorers","name":"restorers","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.personsFind},model:{value:(_vm.reel.restoration.data.restorers.data),callback:function ($$v) {_vm.$set(_vm.reel.restoration.data.restorers, "data", $$v)},expression:"reel.restoration.data.restorers.data"}})],1)])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Digitalizzazione eseguita?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digit),expression:"reel.digit"}],staticClass:"form-control",attrs:{"id":"digit","name":"digit","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel, "digit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"data_digit"}},[_vm._v("Data digitalizzazione")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",attrs:{"id":"data_digit","name":"data_digit","config":_vm.config,"disabled":_vm.disabled},on:{"dp-error":_vm.error},model:{value:(_vm.reel.digitazion.data.data),callback:function ($$v) {_vm.$set(_vm.reel.digitazion.data, "data", $$v)},expression:"reel.digitazion.data.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"freq1"}},[_vm._v("Frame rate")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.freq1),expression:"reel.digitazion.data.freq1"}],staticClass:"form-control",attrs:{"id":"freq1","name":"freq1","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.digitazion.data, "freq1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.freq1),function(freq,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(freq)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"velocita"}},[_vm._v("Velocità scansione")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.velocita),expression:"reel.digitazion.data.velocita"}],staticClass:"form-control",attrs:{"id":"velocita","name":"freq1","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.digitazion.data, "velocita", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.velocity),function(velocita,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(velocita)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note_d"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.note),expression:"reel.digitazion.data.note"}],staticClass:"form-control",attrs:{"id":"note_d","name":"note_d","disabled":_vm.disabled},domProps:{"value":(_vm.reel.digitazion.data.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.digitazion.data, "note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"digiters"}},[_vm._v("Operatore/i")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.persons,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"digiters","name":"digiters","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.personsFind},model:{value:(_vm.reel.digitazion.data.digiters.data),callback:function ($$v) {_vm.$set(_vm.reel.digitazion.data.digiters, "data", $$v)},expression:"reel.digitazion.data.digiters.data"}})],1)])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sovraesposizione"}},[_vm._v("Sovraesposizione")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.sovraesposizione),expression:"reel.digitazion.data.sovraesposizione"}],staticClass:"form-control",attrs:{"id":"sovraesposizione","name":"sovraesposizione","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.digitazion.data, "sovraesposizione", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.faults),function(fault,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(fault)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sottoesposizione"}},[_vm._v("Sottoesposizione")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.sottoesposizione),expression:"reel.digitazion.data.sottoesposizione"}],staticClass:"form-control",attrs:{"id":"sottoesposizione","name":"sottoesposizione","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.digitazion.data, "sottoesposizione", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.faults),function(fault,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(fault)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sfocature"}},[_vm._v("Sfocature")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.sfocature),expression:"reel.digitazion.data.sfocature"}],staticClass:"form-control",attrs:{"id":"sfocature","name":"sfocature","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.digitazion.data, "sfocature", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.faults),function(fault,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(fault)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"stabilita"}},[_vm._v("Stabilità di ripresa")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.stabilita),expression:"reel.digitazion.data.stabilita"}],staticClass:"form-control",attrs:{"id":"stabilita","name":"stabilita","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reel.digitazion.data, "stabilita", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.shootingStability),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                    "+_vm._s(desc)+"\n                                                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"difetti_note"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.digitazion.data.difetti_note),expression:"reel.digitazion.data.difetti_note"}],staticClass:"form-control",attrs:{"id":"difetti_note","name":"difetti_note","disabled":_vm.disabled},domProps:{"value":(_vm.reel.digitazion.data.difetti_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reel.digitazion.data, "difetti_note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"faultAnalyzers"}},[_vm._v("Operatore/i")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.persons,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"faultAnalyzers","name":"faultAnalyzers","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.personsFind},model:{value:(_vm.reel.digitazion.data.faultAnalyzers.data),callback:function ($$v) {_vm.$set(_vm.reel.digitazion.data.faultAnalyzers, "data", $$v)},expression:"reel.digitazion.data.faultAnalyzers.data"}})],1)])])]),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ul',{attrs:{"id":"restorationgallery"}},_vm._l((_vm.reel.restoration.data.restorationimages.data),function(image){return _c('li',[_c('a',{attrs:{"href":image.url,"target":"_blank"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":image.url}})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"btn btn-xs btn-danger",on:{"click":function($event){$event.preventDefault();return _vm.delRestorationImage(image.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dropzone',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],style:({ border: '2px dashed', height: '200px', width: '100%' }),attrs:{"uploader":_vm.restorationImageUploader}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"text-bold"},[_vm._v("Trascina qui i file da caricare")])],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_3"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Da pubblicare?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.web_enabled),expression:"reel.web_enabled"}],attrs:{"type":"radio","name":"web_enabled","value":"0","disabled":_vm.disabled},domProps:{"checked":_vm._q(_vm.reel.web_enabled,"0")},on:{"change":function($event){return _vm.$set(_vm.reel, "web_enabled", "0")}}}),_vm._v(" No\n                              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.web_enabled),expression:"reel.web_enabled"}],attrs:{"type":"radio","name":"web_enabled","value":"1","disabled":_vm.disabled},domProps:{"checked":_vm._q(_vm.reel.web_enabled,"1")},on:{"change":function($event){return _vm.$set(_vm.reel, "web_enabled", "1")}}}),_vm._v(" Sì\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"web_note"}},[_vm._v("Immagine in evidenza")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.reel.reelimages.data),function(image){return _c('div',{staticClass:"col-md-4"},[_c('a',{attrs:{"href":image.url,"target":"_blank"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100%"},attrs:{"src":image.url}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reel.web_top_image),expression:"reel.web_top_image"}],attrs:{"type":"radio","name":"web_top_image","disabled":_vm.disabled},domProps:{"value":image.id,"checked":_vm._q(_vm.reel.web_top_image,image.id)},on:{"change":function($event){return _vm.$set(_vm.reel, "web_top_image", image.id)}}})])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.saveArchiveWeb.apply(null, arguments)}}},[_vm._v("\n                              Salva info archivio web\n                            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('ul',{staticClass:"nav"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSave),expression:"showSave"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                    Salva\n                                ")]):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                                    Attiva modifiche\n                                ")]):_vm._e()]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                    Cerca\n                                ")]):_vm._e()])])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Identificazione bobina")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#tab_4","data-toggle":"tab"}},[_vm._v("Descrizione bobina")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#tab_2","data-toggle":"tab"}},[_vm._v("Restauro conservativo e digitalizzazione")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#tab_3","data-toggle":"tab"}},[_vm._v("Archivio web")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Stato fisico del film")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Interventi di ripristino")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Digitalizzazione")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Difetti di ripresa")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SLoz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_keywords__ = __webpack_require__("Rii/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("3foD");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    keywordsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },

  data: function data() {
    return {
      keyword: false,
      disabled: true,
      interval: null
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_keywords__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.keyword = response;
    });
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Keywords inserite',
      createButton: {
        display: true,
        text: 'Nuova keyword',
        to: '/keyword'
      }
    });
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_keywords__["a" /* default */].update(_this2.$route.params.id, _this2.keyword);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updateKeyword: function updateKeyword() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_keywords__["a" /* default */].update(this.$route.params.id, this.keyword).then(function (response) {
        toastr.success('La keyword è stata salvata correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "Smkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_microtags__ = __webpack_require__("jzQX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      columns: ['microtag', 'macrotag', 'actions'],
      options: {
        sortable: ['microtag'],
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].index(query);
        }
      },
      loading: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Microtags inseriti',
      createButton: {
        display: true,
        text: 'Nuovo microtag',
        to: 'microtag'
      }
    });
  },


  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].delete(id).then(function (response) {
          _this.$refs.microtags.refresh();
          toastr.success('La microtag è stata rimossa correttamente');
          _this.loading = false;
        }).catch(function (response) {
          _this.loading = false;
        });
      }
    },
    toggleLoading: function toggleLoading() {
      // this.loading = !this.loading
    },
    showMicrotag: function showMicrotag(row) {
      this.$router.push({ name: 'microtagsShow', params: { id: row.row.id } });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "Suwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_places__ = __webpack_require__("sWWJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      columns: ['nome', 'indirizzo', 'actions'],
      options: {
        sortable: ['nome', 'indirizzo'],
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_places__["a" /* default */].index(query);
        }
      },
      loading: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Luoghi inseriti',
      createButton: {
        display: true,
        text: 'Nuovo luogo',
        to: 'place'
      }
    });
  },


  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_places__["a" /* default */].delete(id).then(function (response) {
          _this.$refs.places.refresh();
          toastr.success('Il luogo è stato rimosso correttamente');
          _this.loading = false;
        }).catch(function (response) {
          _this.loading = false;
        });
      }
    },
    toggleLoading: function toggleLoading() {
      // this.loading = !this.loading
    },
    showPlace: function showPlace(row) {
      this.$router.push({ name: 'placesShow', params: { id: row.row.id } });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "T6cY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequencesShow_vue__ = __webpack_require__("GWpP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdb975f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequencesShow_vue__ = __webpack_require__("+rOP");
function injectStyle (ssrContext) {
  __webpack_require__("XiDw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SequencesShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdb975f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SequencesShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TWpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('macrotags-form',{attrs:{"keyword":_vm.keyword,"disabled":_vm.disabled,"showLabels":true},on:{"activate-mod":function($event){return _vm.activateMod()},"click":function($event){return _vm.updateMacrotag()}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tzwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-default"},[_c('div',{staticClass:"box-body"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"pull-right"},[_c('h4',[_c('span',{staticClass:"label label-primary",on:{"click":_vm.next}},[_vm._v("\n                    >\n                  ")])])]),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('h4',[_c('span',{staticClass:"label label-primary"},[_c('strong',[_vm._v(_vm._s(_vm.reel.identificativo))])])])]),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('h4',[_c('span',{staticClass:"label label-primary",on:{"click":_vm.prev}},[_vm._v("\n                    <\n                  ")])])]),_vm._v(" "),_c('li',{staticClass:"pull-right",staticStyle:{"margin-right":"10px"}},[_c('router-link',{attrs:{"to":{ name: 'fundsShow', params: { id: _vm.fund.id }},"tag":"h4"}},[_c('span',{staticClass:"label label-primary"},[_c('strong',[_vm._v(_vm._s(_vm.fund.denominazione))])])])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('reels-form',{attrs:{"reel":_vm.reel,"disabled":_vm.disabled,"showLabels":true,"showSave":true},on:{"activate-mod":function($event){return _vm.activateMod()},"save-archive-web":function($event){return _vm.saveArchiveWeb()},"click":function($event){return _vm.updateReel()}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('v-server-table',{ref:"sequences",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"sequences"},on:{"row-click":_vm.showSequence},scopedSlots:_vm._u([{key:"abstract",fn:function(props){return [_c('div',{staticClass:"form-group"},[_c('textarea',{ref:'abstract-'+props.row.id,staticClass:"form-control",staticStyle:{"height":"150px"},attrs:{"disabled":!_vm.$accessControl.isOperator(_vm.$store.state.profile.profile)},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(props.row.abstract))])])]}},{key:"actions",fn:function(props){return [_c('div',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.removeSequence(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e(),_vm._v(" "),(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.updateSequence(props.row)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e()])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10 text-right"},[(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){$event.preventDefault();return _vm.storeSequence.apply(null, arguments)}}},[_vm._v("\n                Nuova sequenza\n              ")]):_vm._e()])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Sequenze")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U/4w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UNH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_dropzone_vue__ = __webpack_require__("YgLn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23099bce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_dropzone_vue__ = __webpack_require__("FaWy");
function injectStyle (ssrContext) {
  __webpack_require__("bsKQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_dropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23099bce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_dropzone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UhX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('v-server-table',{ref:"macrotags",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"keywords"},on:{"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading,"row-click":_vm.showMacrotags},scopedSlots:_vm._u([{key:"microtags",fn:function(props){return [_c('div',[_c('ul',_vm._l((props.row.microtags.data),function(microtag){return _c('li',[_vm._v(_vm._s(microtag.microtag))])}),0)])]}},{key:"actions",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V/Yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__("rMyF");


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/profile');
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].post('/profile/update', data);
  },
  password: function password(data) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].post('/profile/password', {
      password: data
    });
  }
});

/***/ }),

/***/ "Vp6e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W9/X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "WBeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_sequence__ = __webpack_require__("3vTe");



/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/sequences', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/sequences/' + id + '?include=reel,fund').then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_1__models_sequence__["a" /* default */](false, response.data.data);
    });
  },
  prev: function prev(id) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/sequences/' + id + '/prev?include=reel,fund');
  },
  next: function next(id) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/sequences/' + id + '/next?include=reel,fund');
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].post('/sequences', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].patch('/sequences/' + id, data.prepareForSend());
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].delete('/sequences/' + id);
  },
  deleteImage: function deleteImage(sequenceId, imageId) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].delete('/sequences/' + sequenceId + '/sequenceimage/' + imageId);
  }
});

/***/ }),

/***/ "WMJC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_reels__ = __webpack_require__("R3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("xgCv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_reel__ = __webpack_require__("gQ+i");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    reelsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      reel: new __WEBPACK_IMPORTED_MODULE_3__models_reel__["a" /* default */](true, undefined, this.$store.state.profile.profile.person.data),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuova bobina',
      createButton: { display: false }
    });
    this.$emit('addBackgroundColor', 'rgb(202,94,66)');
  },


  methods: {
    storeReel: function storeReel(reel) {
      var _this = this;

      this.loader = true;
      __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].store(reel).then(function (response) {
        toastr.success('La bobina è stata inserita correttamente');
        _this.$router.replace({ name: 'reelsShow', params: { id: response.data.data.id } });
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "WoY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login-box-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[(_vm.infoError)?_c('div',{staticClass:"callout callout-danger text-left"},[_c('h4',[_vm._v("Errore")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"login-box-msg"},[_vm._v("Effettua il login per iniziare la sessione")]),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-envelope form-control-feedback"})]),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-lock form-control-feedback"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-offset-7 col-xs-5"},[_c('button',{staticClass:"btn btn-primary btn-block\n",on:{"click":_vm.login}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                            Login\n                        ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-logo"},[_c('b',[_vm._v("Cine")]),_vm._v("Scatti\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wogg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("qmJt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785e0a38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("5zmG");
function injectStyle (ssrContext) {
  __webpack_require__("OA/g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785e0a38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X/gF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XKo0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  pageTitle: null,
  createButton: {
    display: false,
    text: null,
    to: null
  },
  actualFund: null,
  actualReel: null
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].SET_HEADER_STATE, function (state, data) {
  state.pageTitle = data.pageTitle;
  state.createButton = data.createButton;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].SET_ACTUAL_FUND, function (state, data) {
  state.actualFund = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].SET_ACTUAL_REEL, function (state, data) {
  state.actualReel = data;
}), _mutations);

var actions = {};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "Xcg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('TopBar'),_vm._v(" "),_c('SideBar'),_vm._v(" "),_c('div',{staticClass:"content-wrapper",style:({ 'background-color': _vm.backgroundColor })},[_c('section',{staticClass:"content-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('h3',[_vm._v("\n                        "+_vm._s(_vm.pageTitle)+"\n                    ")])]),_vm._v(" "),(_vm.createButton.display)?_c('div',{staticClass:"col-md-4 text-right"},[_c('h1',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":_vm.createButton.to}},[_vm._v("\n                            "+_vm._s(_vm.createButton.text)+"\n                        ")]):_vm._e()],1)]):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""},on:{"after-enter":_vm.afterEnter}},[_c('router-view',{key:_vm.$route.path,on:{"addBackgroundColor":_vm.addBackgroundColor}})],1)],1),_vm._v(" "),_c('Foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XiDw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XikV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xs64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  saveState: true,
  filterable: false,
  responseAdapter: function (resp) {
    return {
      data: resp.data.data,
      count: resp.data.meta.pagination.total
    }
  },
  texts: {
    count: 'Dal {from} al {to} di {count} records',
    filter: 'Filter Results:',
    filterPlaceholder: 'Search query',
    limit: 'Record per pagina: ',
    noResults: 'No matching records',
    page: 'Page:',
    // for dropdown pagination filterBy: 'Filter by {column}',
    loading:'Carico i dati....',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
  },
  headings: {
    'created_at': 'Inserito il',
    'actions': ''
  }
});

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YO57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("66Xx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca29112c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("8oLI");
function injectStyle (ssrContext) {
  __webpack_require__("fRXA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca29112c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca29112c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YSSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__("rMyF");


/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index() {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/film-brands');
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__ = __webpack_require__("0Kyw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login_vue__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile_vue__ = __webpack_require__("o9cx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_funds_Index_vue__ = __webpack_require__("lTyD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_funds_Create_vue__ = __webpack_require__("9J+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_funds_Show_vue__ = __webpack_require__("Wogg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_funds_Search_vue__ = __webpack_require__("Mplq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_persons_Index_vue__ = __webpack_require__("Q/lz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_persons_Create_vue__ = __webpack_require__("OAGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_persons_Show_vue__ = __webpack_require__("jTbx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_places_Index_vue__ = __webpack_require__("I+lN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_places_Create_vue__ = __webpack_require__("msTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_places_Show_vue__ = __webpack_require__("2U5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_keywords_Index_vue__ = __webpack_require__("MjDo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_keywords_Create_vue__ = __webpack_require__("KxUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_keywords_Show_vue__ = __webpack_require__("5ISw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_macrotags_Index_vue__ = __webpack_require__("Oa1L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_macrotags_Create_vue__ = __webpack_require__("wh6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_macrotags_Show_vue__ = __webpack_require__("M71J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_microtags_Index_vue__ = __webpack_require__("AG9N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_microtags_Create_vue__ = __webpack_require__("jaEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_microtags_Show_vue__ = __webpack_require__("tGQc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_reels_Show_vue__ = __webpack_require__("suPm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_reels_Create_vue__ = __webpack_require__("8aDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_reels_Search_vue__ = __webpack_require__("0hpA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_sequences_SequencesShow_vue__ = __webpack_require__("T6cY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_sequences_SequencesCreate_vue__ = __webpack_require__("ITCS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_collections_CollectionsIndex_vue__ = __webpack_require__("sbQT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_collections_CollectionsShow_vue__ = __webpack_require__("phwD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_collections_CollectionsCreate_vue__ = __webpack_require__("yhWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_layout_BaseComponent_vue__ = __webpack_require__("kxkm");














































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/',
  routes: [{
    path: '/',
    name: 'baseComponent',
    component: __WEBPACK_IMPORTED_MODULE_32__components_layout_BaseComponent_vue__["a" /* default */],
    redirect: 'funds',
    children: [
    //
    // FUNDS
    {
      path: 'funds',
      name: 'fundsIndex',
      component: __WEBPACK_IMPORTED_MODULE_5__components_funds_Index_vue__["a" /* default */]
    }, {
      path: 'fund',
      name: 'fundsCreate',
      component: __WEBPACK_IMPORTED_MODULE_6__components_funds_Create_vue__["a" /* default */]
    }, {
      path: 'funds/:id',
      name: 'fundsShow',
      component: __WEBPACK_IMPORTED_MODULE_7__components_funds_Show_vue__["a" /* default */]
    }, {
      path: 'funds-search',
      name: 'fundsSearch',
      component: __WEBPACK_IMPORTED_MODULE_8__components_funds_Search_vue__["a" /* default */]
    },
    //
    // REELS
    {
      path: 'reel',
      name: 'reelsCreate',
      component: __WEBPACK_IMPORTED_MODULE_25__components_reels_Create_vue__["a" /* default */]
    }, {
      path: 'reels/:id',
      name: 'reelsShow',
      component: __WEBPACK_IMPORTED_MODULE_24__components_reels_Show_vue__["a" /* default */]
    }, {
      path: 'reels-search',
      name: 'reelsSearch',
      component: __WEBPACK_IMPORTED_MODULE_26__components_reels_Search_vue__["a" /* default */]
    },
    //
    // SEQUENCES
    {
      path: 'sequence',
      name: 'sequencesCreate',
      component: __WEBPACK_IMPORTED_MODULE_28__components_sequences_SequencesCreate_vue__["a" /* default */]
    }, {
      path: 'sequences?id=:id&showMap=:showMap',
      name: 'sequencesShow',
      component: __WEBPACK_IMPORTED_MODULE_27__components_sequences_SequencesShow_vue__["a" /* default */]
    },
    //
    // PERSONS
    {
      path: 'persons',
      name: 'personsIndex',
      component: __WEBPACK_IMPORTED_MODULE_9__components_persons_Index_vue__["a" /* default */]
    }, {
      path: 'person',
      name: 'personsCreate',
      component: __WEBPACK_IMPORTED_MODULE_10__components_persons_Create_vue__["a" /* default */]
    }, {
      path: 'persons/:id',
      name: 'personsShow',
      component: __WEBPACK_IMPORTED_MODULE_11__components_persons_Show_vue__["a" /* default */]
    },
    //
    // PLACES
    {
      path: 'places',
      name: 'placesIndex',
      component: __WEBPACK_IMPORTED_MODULE_12__components_places_Index_vue__["a" /* default */]
    }, {
      path: 'place',
      name: 'placesCreate',
      component: __WEBPACK_IMPORTED_MODULE_13__components_places_Create_vue__["a" /* default */]
    }, {
      path: 'places/:id',
      name: 'placesShow',
      component: __WEBPACK_IMPORTED_MODULE_14__components_places_Show_vue__["a" /* default */]
    },
    //
    // KEYWORDS
    {
      path: 'keywords',
      name: 'keywordsIndex',
      component: __WEBPACK_IMPORTED_MODULE_15__components_keywords_Index_vue__["a" /* default */]
    }, {
      path: 'keyword',
      name: 'keywordsCreate',
      component: __WEBPACK_IMPORTED_MODULE_16__components_keywords_Create_vue__["a" /* default */]
    }, {
      path: 'keywords/:id',
      name: 'keywordsShow',
      component: __WEBPACK_IMPORTED_MODULE_17__components_keywords_Show_vue__["a" /* default */]
    },
    //
    // MACROTAGS
    {
      path: 'macrotags',
      name: 'macrotagsIndex',
      component: __WEBPACK_IMPORTED_MODULE_18__components_macrotags_Index_vue__["a" /* default */]
    }, {
      path: 'macrotag',
      name: 'macrotagsCreate',
      component: __WEBPACK_IMPORTED_MODULE_19__components_macrotags_Create_vue__["a" /* default */]
    }, {
      path: 'macrotags/:id',
      name: 'macrotagsShow',
      component: __WEBPACK_IMPORTED_MODULE_20__components_macrotags_Show_vue__["a" /* default */]
    },
    //
    // MICROTAGS
    {
      path: 'microtags',
      name: 'microtagsIndex',
      component: __WEBPACK_IMPORTED_MODULE_21__components_microtags_Index_vue__["a" /* default */]
    }, {
      path: 'microtag',
      name: 'microtagsCreate',
      component: __WEBPACK_IMPORTED_MODULE_22__components_microtags_Create_vue__["a" /* default */]
    }, {
      path: 'microtags/:id',
      name: 'microtagsShow',
      component: __WEBPACK_IMPORTED_MODULE_23__components_microtags_Show_vue__["a" /* default */]
    },
    //
    // PROFILE
    {
      path: 'profile',
      name: 'profile',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Profile_vue__["a" /* default */]
    },
    //
    // COLLECTIONS
    {
      path: 'collections',
      name: 'collectionsIndex',
      component: __WEBPACK_IMPORTED_MODULE_29__components_collections_CollectionsIndex_vue__["a" /* default */]
    }, {
      path: 'collection',
      name: 'collectionsCreate',
      component: __WEBPACK_IMPORTED_MODULE_31__components_collections_CollectionsCreate_vue__["a" /* default */]
    }, {
      path: 'collections/:id',
      name: 'collectionsShow',
      component: __WEBPACK_IMPORTED_MODULE_30__components_collections_CollectionsShow_vue__["a" /* default */]
    }]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login_vue__["a" /* default */]
  }, {
    path: '/logout',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YgLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd__ = __webpack_require__("wKfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dropActiveClassName: {
      type: String,
      default: 'vue-fine-uploader-dropzone-active'
    },
    multiple: {
      type: Boolean
    },
    onDropError: {
      type: Function
    },
    onProcessingDroppedFiles: {
      type: Function
    },
    onProcessingDroppedFilesComplete: {
      type: Function
    },
    uploader: {
      type: Object, required: true
    }
  },

  mounted: function mounted() {
    this._registerDropzone();
  },
  updated: function updated() {
    this._registerDropzone();
  },
  beforeDestroy: function beforeDestroy() {
    this._qqDropzone && this._qqDropzone.dispose();
  },


  methods: {
    _onDropError: function _onDropError(errorCode, errorData) {
      console.error(errorCode, errorData);

      this.onDropError && this.onDropError(errorCode, errorData);
    },
    _onProcessingDroppedFilesComplete: function _onProcessingDroppedFilesComplete(files) {
      this.uploader.methods.addFiles(files);

      this.onProcessingDroppedFilesComplete && this.onProcessingDroppedFilesComplete(files);
    },
    _registerDropzone: function _registerDropzone() {
      this._qqDropzone && this._qqDropzone.dispose();

      var dropzoneEl = this.$refs.element || this.$refs.dropZone;

      this._qqDropzone = new __WEBPACK_IMPORTED_MODULE_0_fine_uploader_lib_dnd___default.a.DragAndDrop({
        allowMultipleItems: !!this.multiple,
        callbacks: {
          dropError: this._onDropError.bind(this),
          processingDroppedFiles: this.onProcessingDroppedFiles || function () {},
          processingDroppedFilesComplete: this._onProcessingDroppedFilesComplete.bind(this)
        },
        classes: {
          dropActive: this.dropActiveClassName || ''
        },
        dropZoneElements: [dropzoneEl]
      });
    }
  }
});

/***/ }),

/***/ "Yrvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("/Cq+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d5e45f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("vwNN");
function injectStyle (ssrContext) {
  __webpack_require__("bE6E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02d5e45f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d5e45f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yt18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_microtags__ = __webpack_require__("jzQX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("0nBB");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    microtagsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },

  data: function data() {
    return {
      microtag: false,
      disabled: true,
      interval: null
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.microtag = response;
    });
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Microtags inseriti',
      createButton: {
        display: true,
        text: 'Nuovo microtag',
        to: '/microtag'
      }
    });
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].update(_this2.$route.params.id, _this2.microtag);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updateMicrotag: function updateMicrotag() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].update(this.$route.params.id, this.microtag).then(function (response) {
        toastr.success('Il microtag è stato salvato correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "Z9dx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-static-top"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"navbar-custom-menu"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"dropdown user user-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('span',{},[_vm._v(_vm._s(_vm.profile.name))])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"user-header"},[_c('p',[_vm._v("\n                                "+_vm._s(_vm.profile.name)+" - "+_vm._s(_vm.profile.email)+"\n                                "),_c('small',[_vm._v("Registrato il "+_vm._s(_vm._f("dateFormatBase")(_vm.profile.created_at)))])]),_vm._v(" "),(_vm.profile.entity)?_c('p',[_vm._v("\n                                Ente: "),_c('strong',[_vm._v(_vm._s(_vm.profile.entity.data.name))])]):_vm._e(),_vm._v(" "),(_vm.profile.archive)?_c('p',[_vm._v("\n                                Archivio: "),_c('strong',[_vm._v(_vm._s(_vm.profile.archive.data.nome))])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"user-footer"},[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('div',{staticClass:"pull-left"},[_c('router-link',{staticClass:"btn btn-default btn-flat",attrs:{"to":{ name: 'profile'}}},[_vm._v("Profilo\n                                ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn btn-default btn-flat",attrs:{"to":{ name: 'logout'}}},[_vm._v("Logout\n                                ")])],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"href":"#"}},[_c('span',{staticClass:"logo-mini"},[_c('b',[_vm._v("C")]),_vm._v("SCA")]),_vm._v(" "),_c('span',{staticClass:"logo-lg"},[_c('b',[_vm._v("Cine")]),_vm._v("Scatti")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sidebar-toggle",attrs:{"href":"#","data-toggle":"push-menu","role":"button"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Abilita la navigazione")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a87j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "atvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "au+E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__ = __webpack_require__("qmkN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_583719ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__ = __webpack_require__("MMjd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_583719ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bE6E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bh45":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "bn8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('keywords-form',{attrs:{"keyword":_vm.keyword,"disabled":_vm.disabled,"showLabels":true},on:{"activate-mod":function($event){return _vm.activateMod()},"click":function($event){return _vm.updateKeyword()}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bsKQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c5O7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_funds__ = __webpack_require__("ybAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("zeKe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_fund__ = __webpack_require__("FHMM");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    fundsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fund: new __WEBPACK_IMPORTED_MODULE_3__models_fund__["a" /* default */](true),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuovo fondo',
      createButton: { display: false }
    });
    this.$emit('addBackgroundColor', 'rgb(138,163,157)');
  },


  methods: {
    storeFund: function storeFund(fund) {
      var _this = this;

      this.loader = true;
      fund.archive_id = this.$store.state.profile.profile.archive.data.id;
      __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].store(fund).then(function (response) {
        toastr.success('Il fondo è stato inserito correttamente');
        _this.$router.push('/funds');
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "crw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue__ = __webpack_require__("zeKe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_funds__ = __webpack_require__("ybAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_fund__ = __webpack_require__("FHMM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FundsTab__ = __webpack_require__("yt2h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    fundsForm: __WEBPACK_IMPORTED_MODULE_1__Form_vue__["a" /* default */],
    fundsTab: __WEBPACK_IMPORTED_MODULE_4__components_FundsTab__["a" /* default */]
  },

  data: function data() {
    return {
      fund: new __WEBPACK_IMPORTED_MODULE_3__models_fund__["a" /* default */](false, undefined),
      funds: false,
      firstAccess: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('keypress', function (e) {
      if (e.keyCode === 13) {
        _this.$refs.fundsRef.refresh();
        setTimeout(function () {
          _this.$scrollTo('#fundsId');
        }, 100);
      }
    });
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Cerca fondi',
      createButton: { display: false }
    });
    this.$emit('addBackgroundColor', 'rgb(138,163,157)');
  },


  methods: {
    search: function search() {
      this.firstAccess = false;
      this.$refs.fundsRef.refresh();
      this.$scrollTo('#fundsId');
    },
    showFund: function showFund(id) {
      this.$router.push({ name: 'fundsShow', params: { id: id } });
    },

    requestFunction: function requestFunction(query) {
      if (!this.firstAccess) {
        return __WEBPACK_IMPORTED_MODULE_2__api_funds__["a" /* default */].search(this.fund, query);
      }
      this.firstAccess = false;
      return __WEBPACK_IMPORTED_MODULE_2__api_funds__["a" /* default */].search({ 'id': 111111 }, query);
    }
  }
});

/***/ }),

/***/ "dmV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__ = __webpack_require__("49VO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93736ca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__ = __webpack_require__("Z9dx");
function injectStyle (ssrContext) {
  __webpack_require__("oWEZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93736ca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ds2D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_microtags__ = __webpack_require__("jzQX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("0nBB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_microtag__ = __webpack_require__("xLnc");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    microtagsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },
  data: function data() {
    return {
      microtag: new __WEBPACK_IMPORTED_MODULE_3__models_microtag__["a" /* default */](),
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuova microtag',
      createButton: { display: false }
    });
  },


  methods: {
    storeMicrotag: function storeMicrotag(microtag) {
      var _this = this;

      this.loader = true;
      microtag.archive_id = this.$store.state.profile.profile.archive.data.id;
      __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].store(microtag).then(function (response) {
        toastr.success('La microtag è stata inserita correttamente');
        _this.$router.push('/microtags');
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "fCJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body box-profile"},[_c('form',{attrs:{"data-vv-scope":"profile"},on:{"submit":function($event){$event.preventDefault();return _vm.updateProfile.apply(null, arguments)}}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('name')}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome e cognome")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.profile.name),expression:"profile.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","name":"name"},domProps:{"value":(_vm.profile.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('name')),expression:"errors.has('name')"}],staticClass:"help-block"},[_vm._v("Devi inserire il nome")])]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('email')}},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.profile.email),expression:"profile.email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","name":"email"},domProps:{"value":(_vm.profile.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"help-block"},[_vm._v("Devi inserire un'email valida")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block"},[(_vm.loaderProfile)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                Salva\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body box-profile"},[_c('form',{attrs:{"data-vv-scope":"password"},on:{"submit":function($event){$event.preventDefault();return _vm.password.apply(null, arguments)}}},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('newPassword')}},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"form-control",attrs:{"type":"password","id":"newPassword","name":"newPassword","placeholder":"nuova password"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('newPassword')),expression:"errors.has('newPassword')"}],staticClass:"help-block"},[_vm._v("Devi inserire la password")])]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('newPasswordRepeat')}},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:newPassword'),expression:"'required|confirmed:newPassword'"},{name:"model",rawName:"v-model",value:(_vm.newPasswordRepeat),expression:"newPasswordRepeat"}],staticClass:"form-control",attrs:{"type":"password","id":"newPasswordRepeat","name":"newPasswordRepeat","placeholder":"ripeti password"},domProps:{"value":(_vm.newPasswordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPasswordRepeat=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('newPasswordRepeat')),expression:"errors.has('newPasswordRepeat')"}],staticClass:"help-block"},[_vm._v("Le due password non coincidono")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block\n"},[(_vm.loaderPassword)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                Salva nuova password\n                            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_vm._v("\n                            Modifica dati personali\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_vm._v("\n                            Modifica password\n                        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fP+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_persons__ = __webpack_require__("4eBV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      columns: ['nome', 'fondi', 'indirizzo', 'citta', 'actions'],
      options: {
        sortable: ['nome', 'indirizzo', 'citta'],
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].index(query);
        }
      },
      loading: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Persone inserite',
      createButton: {
        display: true,
        text: 'Nuova persona',
        to: 'person'
      }
    });
  },


  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].delete(id).then(function (response) {
          _this.$refs.persons.refresh();
          toastr.success('La persona è stata rimossa correttamente');
          _this.loading = false;
        }).catch(function (response) {
          _this.loading = false;
        });
      }
    },
    toggleLoading: function toggleLoading() {
      // this.loading = !this.loading
    },
    showPerson: function showPerson(row) {
      this.$router.push({ name: 'personsShow', params: { id: row.row.id } });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "fRXA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fV1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sequences__ = __webpack_require__("WBeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SequencesForm_vue__ = __webpack_require__("9wHJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_sequence__ = __webpack_require__("3vTe");
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    sequencesForm: __WEBPACK_IMPORTED_MODULE_2__SequencesForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      sequence: new __WEBPACK_IMPORTED_MODULE_3__models_sequence__["a" /* default */](true),
      reel: this.$store.state.ui.actualReel,
      loader: false
    };
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Inserisci nuova sequenza',
      createButton: { display: false }
    });
    this.$emit('addBackgroundColor', 'rgb(234,186,140)');
  },


  methods: {
    storeSequence: function storeSequence(sequence) {
      var _this = this;

      this.loader = true;
      __WEBPACK_IMPORTED_MODULE_1__api_sequences__["a" /* default */].store(sequence).then(function (response) {
        toastr.success('La sequenza è stata inserita correttamente');
        _this.$router.replace({ name: 'sequencesShow', params: { id: response.data.data.id } });
      }).catch(function (response) {
        _this.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "fa5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"pd",staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('reels-form',{attrs:{"reel":_vm.reel,"showLabels":false,"showSearch":true},on:{"search":function($event){return _vm.search(_vm.reel)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('reels-tab',_vm._b({ref:"reelsRef",attrs:{"id":"reelsId"}},'reels-tab',{requestFunction: _vm.requestFunction},false))],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gQ+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__baseModel__ = __webpack_require__("Lb/K");











var Reel = function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Reel, _BaseModel);

  function Reel(create, data, user) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Reel);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reel.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Reel)).call(this));

    _this.digitazion = {
      data: {
        digiters: {},
        faultAnalyzers: {}
      }
    };
    _this.restoration = {
      data: {
        filmAnalyzers: {},
        restorers: {}
      }
    };
    _this.description = {
      data: {
        filmPersons: {},
        places: {},
        // keywords: {}
        macrotags: {},
        microtags: {}
      }
    };
    _this.filmFormats = {};
    _this.filmBrands = {};
    _this.reelimages = {};

    if (create) {
      _this.restoration.data.sindrome_aceto = 0;
      _this.restoration.data.sporco = 2;
      _this.digitazion.data.restringimento = 0;
      _this.restoration.data.colore_decaduto = 0;
      _this.restauro = 0;
      _this.digitazion.data.freq1 = 1;
      _this.digitazion.data.velocita = 1;
      _this.digitazion.data.note = _this.emptyNote;
      _this.digitazion.data.difetti_note = _this.emptyNote;
      _this.note = _this.emptyNote;
      _this.restoration.data.audio_note = _this.emptyNote;
      _this.restoration.data.note = _this.emptyNote;
      _this.restoration.data.interventi_note = _this.emptyNote;
      _this.restoration.data.filmAnalyzers.data = [user];
    }
    if (data !== undefined) {
      if (data.digitazion !== undefined) {
        data.digitazion.data.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["c" /* dpParseDate */])(data.digitazion.data.data);
      }
      if (data.restoration !== undefined) {
        data.restoration.data.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["c" /* dpParseDate */])(data.restoration.data.data);
        data.restoration.data.ult_rev_data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["c" /* dpParseDate */])(data.restoration.data.ult_rev_data);
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
      _this.durata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* secondsToTime */])(_this.durata);
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Reel, [{
    key: 'prepareForSend',
    value: function prepareForSend() {
      var data = _.cloneDeep(this);
      data.durata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["b" /* timeToSeconds */])(data.durata);
      data.digitazion.data.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["d" /* dateFormatServer */])(data.digitazion.data.data);
      data.restoration.data.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["d" /* dateFormatServer */])(data.restoration.data.data);
      data.restoration.data.ult_rev_data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__filters__["d" /* dateFormatServer */])(data.restoration.data.ult_rev_data);

      return data;
    }
  }, {
    key: 'prepareQueryForSearch',
    value: function prepareQueryForSearch() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(Reel.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Reel.prototype), 'prepareQueryForSearch', this).call(this, this);
    }
  }]);

  return Reel;
}(__WEBPACK_IMPORTED_MODULE_9__baseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Reel);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "gkTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("8ebl")));

/***/ }),

/***/ "gq5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.keyword)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword.keyword),expression:"keyword.keyword"}],staticClass:"form-control",attrs:{"type":"text","id":"nome","name":"nome","disabled":_vm.disabled},domProps:{"value":(_vm.keyword.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.keyword, "keyword", $event.target.value)}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block"},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                Salva\n                            ")]):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                                Attiva modifiche\n                            ")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Generali")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hQ4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hQTS")));

/***/ }),

/***/ "hqyI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("M04B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a520ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("9tMs");
function injectStyle (ssrContext) {
  __webpack_require__("Ivuc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14a520ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a520ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iJOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('funds-form',{attrs:{"fund":_vm.fund,"showLabels":false,"showSearch":true},on:{"search":_vm.search}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('funds-tab',_vm._b({ref:"fundsRef",attrs:{"id":"fundsId"}},'funds-tab',{requestFunction: _vm.requestFunction},false))],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iZzY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sequence)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{class:_vm.tab1Class},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Generali")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',{class:_vm.tab2Class},[_c('a',{attrs:{"href":"#tab_3","data-toggle":"tab"}},[_vm._v("Mappa")])]),_vm._v(" "),_c('li',{staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                               Salva\n                           ")]):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                               Attiva modifiche\n                           ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{class:['tab-pane',_vm.tab1Class],attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"titolo_"}},[_vm._v("Titolo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.titolo),expression:"sequence.titolo"}],staticClass:"form-control",attrs:{"type":"text","id":"titolo_","name":"titolo","disabled":true},domProps:{"value":(_vm.sequence.titolo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "titolo", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"abstract"}},[_vm._v("Abstract")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.abstract),expression:"sequence.abstract"}],staticClass:"form-control",attrs:{"id":"abstract","name":"abstract","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.abstract)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "abstract", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"durata"}},[_vm._v("Durata")]),_vm._v(" "),_c('masked-input',{staticClass:"form-control",attrs:{"mask":"11:11:11","placeholder":"00:00:00","id":"durata","name":"durata","disabled":_vm.disabled},model:{value:(_vm.sequence.durata),callback:function ($$v) {_vm.$set(_vm.sequence, "durata", $$v)},expression:"sequence.durata"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"start"}},[_vm._v("Inizio")]),_vm._v(" "),_c('masked-input',{staticClass:"form-control",attrs:{"mask":"11:11:11","placeholder":"00:00:00","id":"start","name":"start","disabled":_vm.disabled},model:{value:(_vm.sequence.start),callback:function ($$v) {_vm.$set(_vm.sequence, "start", $$v)},expression:"sequence.start"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"end"}},[_vm._v("Fine")]),_vm._v(" "),_c('masked-input',{staticClass:"form-control",attrs:{"mask":"11:11:11","placeholder":"00:00:00","id":"end","name":"end","disabled":_vm.disabled},model:{value:(_vm.sequence.end),callback:function ($$v) {_vm.$set(_vm.sequence, "end", $$v)},expression:"sequence.end"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"titolo"}},[_vm._v("Lunghezza")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.lunghezza),expression:"sequence.lunghezza"}],staticClass:"form-control",attrs:{"type":"text","id":"lunghezza","name":"lunghezza","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.lunghezza)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "lunghezza", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"utilizzo"}},[_vm._v("Utilizzo")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.utilizzo),expression:"sequence.utilizzo"}],staticClass:"form-control",attrs:{"id":"utilizzo","name":"utilizzo","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.utilizzo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "utilizzo", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.note),expression:"sequence.note"}],staticClass:"form-control",attrs:{"id":"note","name":"note","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"fuori_catalogo"}},[_vm._v("Fuori catalogo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.fuori_catalogo),expression:"sequence.fuori_catalogo"}],staticClass:"form-control",attrs:{"id":"fuori_catalogo","name":"fuori_catalogo","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sequence, "fuori_catalogo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.yn),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                                                       "+_vm._s(desc)+"\n                                                   ")])})],2)])])])]),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ul',{attrs:{"id":"gallery"}},_vm._l((_vm.sequence.sequenceimages.data),function(image){return _c('li',[_c('a',{attrs:{"href":image.url,"target":"_blank"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":image.url}})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"btn btn-xs btn-danger",on:{"click":function($event){$event.preventDefault();return _vm.delImage(image.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dropzone',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],style:({ border: '2px dashed', height: '200px', width: '100%' }),attrs:{"uploader":_vm.uploader}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"text-bold"},[_vm._v("Trascina qui i file da caricare")])],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_2"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('description',{attrs:{"description":_vm.sequence.description.data,"persons":_vm.persons,"disabled":_vm.disabled}})],1)])]),_vm._v(" "),_c('div',{class:['tab-pane',_vm.tab2Class],attrs:{"id":"tab_3"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"titolo"}},[_vm._v("Titolo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.titolo),expression:"sequence.titolo"}],staticClass:"form-control",attrs:{"type":"text","id":"titolo","name":"titolo","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.titolo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "titolo", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"map_author"}},[_vm._v("Autore - fondo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.map_author),expression:"sequence.map_author"}],staticClass:"form-control",attrs:{"type":"text","id":"map_author","name":"map_author","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.map_author)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "map_author", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"map_author"}},[_vm._v("Anno")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.map_year),expression:"sequence.map_year"}],staticClass:"form-control",attrs:{"type":"text","id":"map_year","name":"map_year","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.map_year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "map_year", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"map_abstract"}},[_vm._v("Abstract mappa")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.map_abstract),expression:"sequence.map_abstract"}],staticClass:"form-control",attrs:{"id":"map_abstract","name":"map_abstract","disabled":_vm.disabled},domProps:{"value":(_vm.sequence.map_abstract)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sequence, "map_abstract", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"text-bold"},[_vm._v("Localizzazione")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('gmap-autocomplete',{staticClass:"form-control",attrs:{"placeholder":"Cerca località","disabled":_vm.disabled},on:{"place_changed":_vm.setPlace,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}})],1),_vm._v(" "),_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"500px","height":"300px"},attrs:{"center":_vm.marker.position,"zoom":12,"map-type-id":"roadmap","options":{
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: true,
  disableDefaultUi: false
}}},[(_vm.marker)?_c('GmapMarker',{attrs:{"position":_vm.marker.position,"draggable":!_vm.disabled},on:{"dragend":_vm.markerDragEnd}}):_vm._e()],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"text-bold"},[_vm._v("Clip")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.sequence.video && !_vm.uploading),expression:"sequence.video && !uploading"}],ref:"video",attrs:{"src":_vm.sequence.video,"controls":""}})])]):_vm._e(),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"col-md-12"},[_c('span',{staticClass:"text-bold"},[_vm._v("Trascina qui la clip")]),_vm._v(" "),_c('dropzone',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],style:({ border: '2px dashed', height: '200px', width: '100%' }),attrs:{"uploader":_vm.videoUploader}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploading),expression:"uploading"}],staticClass:"box"},[_vm._m(1)])],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"collections"}},[_vm._v("Raccolte")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.collections,"multiple":true,"track-by":"id","label":"title","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"collections","name":"collections","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.collectionsFind},model:{value:(_vm.sequence.collections.data),callback:function ($$v) {_vm.$set(_vm.sequence.collections, "data", $$v)},expression:"sequence.collections.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Pubblicato")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sequence.published),expression:"sequence.published"}],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.sequence.published)?_vm._i(_vm.sequence.published,null)>-1:(_vm.sequence.published)},on:{"change":function($event){var $$a=_vm.sequence.published,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.sequence, "published", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.sequence, "published", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.sequence, "published", $$c)}}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Vai alle raccolte")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.sequence.collections.data),function(collection){return _c('router-link',{key:collection.id,attrs:{"to":{ name: 'collectionsShow', params: { id: collection.id }}}},[_c('span',{staticClass:"label label-primary"},[_c('strong',[_vm._v(_vm._s(collection.title))])]),_vm._v("\n                                                    \n                                               ")])})],2)])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                           Salva\n                                       ")]):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                                           Attiva modifiche\n                                       ")]):_vm._e()])])])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#tab_2","data-toggle":"tab"}},[_vm._v("Descrizione")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jJty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      version: "1.5.0"
    };
  }
});

/***/ }),

/***/ "jTbx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("/fgc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fd63ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("qinV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fd63ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jaEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("ds2D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd1bb6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("mtF/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd1bb6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jzQX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_microtag__ = __webpack_require__("xLnc");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/microtags?include=macrotag', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/microtags/' + id).then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_microtag__["a" /* default */](response.data.data);
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/microtags', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/microtags/' + id, data.prepareForSend());
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/microtags', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  select: function select(data) {
    var microtag = new __WEBPACK_IMPORTED_MODULE_2__models_microtag__["a" /* default */]();
    microtag.microtag = data;
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/microtags', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(microtag),
        limit: 100,
        orderBy: 'microtag'
      }
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/microtags/' + id);
  }
});

/***/ }),

/***/ "k307":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('places-form',{attrs:{"place":_vm.place,"disabled":_vm.disabled,"showLabels":true},on:{"activate-mod":function($event){return _vm.activateMod()},"click":function($event){return _vm.updatePlace()}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k3bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fund)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSave),expression:"showSave"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n              Salva\n            ")]):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n              Attiva modifiche\n            ")]):_vm._e()]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n              Cerca\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"denominazione"}},[_vm._v("Denominazione")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.denominazione),expression:"fund.denominazione"}],staticClass:"form-control",attrs:{"type":"text","id":"denominazione","name":"denominazione","disabled":_vm.disabled},domProps:{"value":(_vm.fund.denominazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "denominazione", $event.target.value)}}})])])]),_vm._v(" "),(!_vm.fund.isNew)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"consistenza"}},[_vm._v("Consistenza")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.consistenza),expression:"fund.consistenza"}],staticClass:"form-control",attrs:{"type":"number","id":"consistenza","name":"consistenza","disabled":"disabled"},domProps:{"value":(_vm.fund.consistenza)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "consistenza", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(!_vm.fund.isNew)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Formati")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.fund.filmFormats.data),function(format){return _c('span',{staticClass:"multiselect__tag"},[_c('span',[_vm._v(_vm._s(format.name))])])})],2)])]):_vm._e(),_vm._v(" "),(!_vm.fund.isNew)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"40px"}},[_c('label',{attrs:{"for":"slider"}},[_vm._v("Anno inizio e fine")]),_vm._v(" "),_c('vue-slider',{ref:"slider",attrs:{"id":"slider","min":1920,"max":1990,"tooltip-dir":"bottom","disabled":true},model:{value:(_vm.fund.range_anni),callback:function ($$v) {_vm.$set(_vm.fund, "range_anni", $$v)},expression:"fund.range_anni"}})],1)])]):_vm._e(),_vm._v(" "),(!_vm.fund.isNew)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"durata"}},[_vm._v("Durata totale fondo (h/m/s)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.durata),expression:"fund.durata"}],staticClass:"form-control",attrs:{"type":"text","id":"durata","name":"durata","disabled":true},domProps:{"value":(_vm.fund.durata)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "durata", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(!_vm.fund.isNew)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lunghezza"}},[_vm._v("Lunghezza totale fondo in metri")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.lunghezza),expression:"fund.lunghezza"}],staticClass:"form-control",attrs:{"type":"text","id":"lunghezza","name":"lunghezza","disabled":true},domProps:{"value":(_vm.fund.lunghezza)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "lunghezza", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"conservazione_stato"}},[_vm._v("Stato di conservazione generale")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.conservazione_stato),expression:"fund.conservazione_stato"}],staticClass:"form-control",attrs:{"id":"conservazione_stato","name":"conservazione_stato","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fund, "conservazione_stato", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.conservazione_stati),function(stato,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                          "+_vm._s(stato)+"\n                        ")])})],2)])])]),_vm._v(" "),(!_vm.fund.isNew)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"digitalizzazione"}},[_vm._v("Digitalizzazione")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.digitalizzazione),expression:"fund.digitalizzazione"}],staticClass:"form-control",attrs:{"type":"text","id":"digitalizzazione","name":"digitalizzazione","disabled":true},domProps:{"value":(_vm.fund.digitalizzazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "digitalizzazione", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(!_vm.fund.isNew)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"catalogazione"}},[_vm._v("Catalogazione")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.catalogazione),expression:"fund.catalogazione"}],staticClass:"form-control",attrs:{"type":"text","id":"catalogazione","name":"catalogazione","disabled":true},domProps:{"value":(_vm.fund.catalogazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "catalogazione", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note_generali"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.note_generali),expression:"fund.note_generali"}],staticClass:"form-control",attrs:{"id":"note_generali","name":"note_generali","disabled":_vm.disabled},domProps:{"value":(_vm.fund.note_generali)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "note_generali", $event.target.value)}}})])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"acquisizione_data"}},[_vm._v("Data acquisizione")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",attrs:{"id":"acquisizione_data","name":"acquisizione_data","config":_vm.config,"disabled":_vm.disabled},on:{"dp-error":_vm.error},model:{value:(_vm.fund.acquisizione_data),callback:function ($$v) {_vm.$set(_vm.fund, "acquisizione_data", $$v)},expression:"fund.acquisizione_data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"acquisizione_tipo"}},[_vm._v("Tipologia acquisizione")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.acquisizione_tipo),expression:"fund.acquisizione_tipo"}],staticClass:"form-control",attrs:{"id":"acquisizione_tipo","name":"acquisizione_tipo","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fund, "acquisizione_tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.donazione_tipi),function(donazione_tipo,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                          "+_vm._s(donazione_tipo)+"\n                        ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"donors"}},[_vm._v("Titolare/i del fondo")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.persons,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"donors","name":"donors","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.personsFind},model:{value:(_vm.fund.donors.data),callback:function ($$v) {_vm.$set(_vm.fund.donors, "data", $$v)},expression:"fund.donors.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"collocazione"}},[_vm._v("Collocazione pellicole")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.collocazione),expression:"fund.collocazione"}],staticClass:"form-control",attrs:{"type":"text","id":"collocazione","name":"collocazione","disabled":_vm.disabled},domProps:{"value":(_vm.fund.collocazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "collocazione", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nas_collocazione"}},[_vm._v("Collocazione nas")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.nas_collocazione),expression:"fund.nas_collocazione"}],staticClass:"form-control",attrs:{"type":"text","id":"nas_collocazione","name":"nas_collocazione","disabled":_vm.disabled},domProps:{"value":(_vm.fund.nas_collocazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "nas_collocazione", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nas_collocazione"}},[_vm._v("Collocazione lto")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.lto_collocazione),expression:"fund.lto_collocazione"}],staticClass:"form-control",attrs:{"type":"text","id":"lto_collocazione","name":"lto_collocazione","disabled":_vm.disabled},domProps:{"value":(_vm.fund.lto_collocazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "lto_collocazione", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"acquisizione_note"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.acquisizione_note),expression:"fund.acquisizione_note"}],staticClass:"form-control",attrs:{"id":"acquisizione_note","name":"acquisizione_note","disabled":_vm.disabled},domProps:{"value":(_vm.fund.acquisizione_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "acquisizione_note", $event.target.value)}}})])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"storia_archivistica"}},[_vm._v("Storia archivistica")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.storia_archivistica),expression:"fund.storia_archivistica"}],staticClass:"form-control",attrs:{"id":"storia_archivistica","name":"storia_archivistica","disabled":_vm.disabled},domProps:{"value":(_vm.fund.storia_archivistica)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "storia_archivistica", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"criteri_ordinamento"}},[_vm._v("Criteri di ordinamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.criteri_ordinamento),expression:"fund.criteri_ordinamento"}],staticClass:"form-control",attrs:{"type":"text","id":"criteri_ordinamento","name":"criteri_ordinamento","disabled":_vm.disabled},domProps:{"value":(_vm.fund.criteri_ordinamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "criteri_ordinamento", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"condizione_giuridica"}},[_vm._v("Condizione giuridica")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.condizione_giuridica),expression:"fund.condizione_giuridica"}],staticClass:"form-control",attrs:{"id":"condizione_giuridica","name":"condizione_giuridica","disabled":_vm.disabled},domProps:{"value":(_vm.fund.condizione_giuridica)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "condizione_giuridica", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"materiali_aggiuntivi"}},[_vm._v("Materiali aggiuntivi")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.materiali_aggiuntivi),expression:"fund.materiali_aggiuntivi"}],staticClass:"form-control",attrs:{"id":"materiali_aggiuntivi","name":"materiali_aggiuntivi","disabled":_vm.disabled},domProps:{"value":(_vm.fund.materiali_aggiuntivi)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "materiali_aggiuntivi", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note_archivista"}},[_vm._v("Note archivista")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.note_archivista),expression:"fund.note_archivista"}],staticClass:"form-control",attrs:{"id":"note_archivista","name":"note_archivista","disabled":_vm.disabled},domProps:{"value":(_vm.fund.note_archivista)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "note_archivista", $event.target.value)}}})])])])]),_vm._v(" "),(_vm.showLabels)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ul',{attrs:{"id":"gallery"}},_vm._l((_vm.fund.fundimages.data),function(image){return _c('li',[_c('a',{attrs:{"href":image.url,"target":"_blank"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":image.url}})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"btn btn-xs btn-danger",on:{"click":function($event){$event.preventDefault();return _vm.delImage(image.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dropzone',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],style:({ border: '2px dashed', height: '200px', width: '100%' }),attrs:{"uploader":_vm.uploader}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],staticClass:"text-bold"},[_vm._v("Trascina qui i file da caricare")])],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_2"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"abstract"}},[_vm._v("Descrizione fondo")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.abstract),expression:"fund.abstract"}],staticClass:"form-control",attrs:{"id":"abstract","name":"abstract","disabled":_vm.disabled},domProps:{"value":(_vm.fund.abstract)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "abstract", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note_biografiche"}},[_vm._v("Profilo biografico cineamatore")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.note_biografiche),expression:"fund.note_biografiche"}],staticClass:"form-control",attrs:{"id":"note_biografiche","name":"note_biografiche","disabled":_vm.disabled},domProps:{"value":(_vm.fund.note_biografiche)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "note_biografiche", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"note_descrizione"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.note_descrizione),expression:"fund.note_descrizione"}],staticClass:"form-control",attrs:{"id":"note_descrizione","name":"note_descrizione","disabled":_vm.disabled},domProps:{"value":(_vm.fund.note_descrizione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "note_descrizione", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_3"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"intervista"}},[_vm._v("È stata realizzata un'intervista?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.intervista),expression:"fund.intervista"}],staticClass:"form-control",attrs:{"id":"intervista","name":"intervista","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fund, "intervista", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option'),_vm._v(" "),_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n                          "+_vm._s(desc)+"\n                        ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"intervista_collocazione"}},[_vm._v("Collocazione intervista")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.intervista_collocazione),expression:"fund.intervista_collocazione"}],staticClass:"form-control",attrs:{"type":"text","id":"intervista_collocazione","name":"intervista_collocazione","disabled":_vm.disabled},domProps:{"value":(_vm.fund.intervista_collocazione)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "intervista_collocazione", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"interviewers"}},[_vm._v("Intervistatore/i")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.persons,"multiple":true,"track-by":"id","label":"nome","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"interviewers","name":"interviewers","disabled":_vm.disabled,"clear-on-select":false,"searchable":true},on:{"search-change":_vm.personsFind},model:{value:(_vm.fund.interviewers.data),callback:function ($$v) {_vm.$set(_vm.fund.interviewers, "data", $$v)},expression:"fund.interviewers.data"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"persone_intervistate"}},[_vm._v("Persone intervistate")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.persone_intervistate),expression:"fund.persone_intervistate"}],staticClass:"form-control",attrs:{"id":"persone_intervistate","name":"persone_intervistate","disabled":_vm.disabled},domProps:{"value":(_vm.fund.persone_intervistate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "persone_intervistate", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_4"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Da pubblicare?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.web_enabled),expression:"fund.web_enabled"}],attrs:{"type":"radio","name":"web_enabled","value":"0","disabled":_vm.disabled},domProps:{"checked":_vm._q(_vm.fund.web_enabled,"0")},on:{"change":function($event){return _vm.$set(_vm.fund, "web_enabled", "0")}}}),_vm._v(" No\n                      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.web_enabled),expression:"fund.web_enabled"}],attrs:{"type":"radio","name":"web_enabled","value":"1","disabled":_vm.disabled},domProps:{"checked":_vm._q(_vm.fund.web_enabled,"1")},on:{"change":function($event){return _vm.$set(_vm.fund, "web_enabled", "1")}}}),_vm._v(" Sì\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"web_description"}},[_vm._v("Descrizione fondo")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.web_description),expression:"fund.web_description"}],staticClass:"form-control",attrs:{"id":"web_description","name":"web_description","disabled":_vm.disabled},domProps:{"value":(_vm.fund.web_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "web_description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"web_filmmaker_bio"}},[_vm._v("Profilo biografico cineamatore")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.web_filmmaker_bio),expression:"fund.web_filmmaker_bio"}],staticClass:"form-control",attrs:{"id":"web_filmmaker_bio","name":"web_filmmaker_bio","disabled":_vm.disabled},domProps:{"value":(_vm.fund.web_filmmaker_bio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "web_filmmaker_bio", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"web_note"}},[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.web_note),expression:"fund.web_note"}],staticClass:"form-control",attrs:{"id":"web_note","name":"web_note","disabled":_vm.disabled},domProps:{"value":(_vm.fund.web_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fund, "web_note", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"web_note"}},[_vm._v("Immagine in evidenza")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.fund.fundimages.data),function(image){return _c('div',{staticClass:"col-md-4"},[_c('a',{attrs:{"href":image.url,"target":"_blank"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100%"},attrs:{"src":image.url}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fund.web_top_image),expression:"fund.web_top_image"}],attrs:{"type":"radio","name":"web_top_image","disabled":_vm.disabled},domProps:{"value":image.id,"checked":_vm._q(_vm.fund.web_top_image,image.id)},on:{"change":function($event){return _vm.$set(_vm.fund, "web_top_image", image.id)}}})])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.saveArchiveWeb.apply(null, arguments)}}},[_vm._v("\n                      Salva info archivio web\n                    ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('ul',{staticClass:"nav"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSave),expression:"showSave"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                Salva\n              ")]):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                Attiva modifiche\n              ")]):_vm._e()]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}],staticClass:"pull-right"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                Cerca\n              ")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Identificazione fondo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#tab_2","data-toggle":"tab"}},[_vm._v("Descrizione fondo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#tab_3","data-toggle":"tab"}},[_vm._v("Intervista")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#tab_4","data-toggle":"tab"}},[_vm._v("Archivio web")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-divider"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-divider"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kodO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.microtag)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.microtag.microtag),expression:"microtag.microtag"}],staticClass:"form-control",attrs:{"type":"text","id":"nome","name":"nome","disabled":_vm.disabled},domProps:{"value":(_vm.microtag.microtag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.microtag, "microtag", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"macrotag"}},[_vm._v("Macrotag")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.macrotags,"track-by":"id","label":"macrotag","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"macrotag","name":"macrotag","clear-on-select":false,"searchable":true},on:{"search-change":_vm.macrotagsFind},model:{value:(_vm.microtag.macrotag),callback:function ($$v) {_vm.$set(_vm.microtag, "macrotag", $$v)},expression:"microtag.macrotag"}})],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block"},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                Salva\n              ")]):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                Attiva modifiche\n              ")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_1","data-toggle":"tab"}},[_vm._v("Generali")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kxkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseComponent_vue__ = __webpack_require__("q5jR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584e8050_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseComponent_vue__ = __webpack_require__("Xcg2");
function injectStyle (ssrContext) {
  __webpack_require__("B3kH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-584e8050"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584e8050_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l/6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('v-server-table',{ref:"places",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"places"},on:{"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading,"row-click":_vm.showPlace},scopedSlots:_vm._u([{key:"actions",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lJgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__("rMyF");


/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index() {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* client */].get('/film-formats');
  }
});

/***/ }),

/***/ "lTyD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("zjIo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d366372_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("CnVf");
function injectStyle (ssrContext) {
  __webpack_require__("Go0g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d366372_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lviy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clientDateFormat; });
/* unused harmony export serverDateFromat */
/* unused harmony export timeCodeFromat */
/* unused harmony export dateFormatBase */
/* harmony export (immutable) */ __webpack_exports__["d"] = dateFormatServer;
/* harmony export (immutable) */ __webpack_exports__["c"] = dpParseDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = secondsToTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = timeToSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



var clientDateFormat = 'DD/MM/YYYY';
var serverDateFromat = 'YYYY-MM-DD';
var timeCodeFromat = 'HH:mm:ss';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('dateFormatBase', function (value) {
  return dateFormatBase(value);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('decodeValue', function (value, decoder) {
  if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.decoder.decoders[decoder] !== undefined) {
    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.decoder.decoders[decoder][value];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('secondsToTime', function (value) {
  return secondsToTime(value);
});

function dateFormatBase(value) {
  if (value !== undefined && value !== null) {
    return moment(value.date).format(clientDateFormat);
  }
}

function dateFormatServer(value) {
  if (value !== undefined && value !== null) {
    return value.format(serverDateFromat);
  }
}

function dpParseDate(value) {
  if (value !== undefined && value !== null) {
    return moment(value.date);
  }
}

function secondsToTime(value) {
  if (value !== undefined && value !== null) {
    return moment().startOf('day').seconds(value).format(timeCodeFromat);
  }
}

function timeToSeconds(value) {
  if (value !== undefined && value !== null) {
    return moment.duration(value, timeCodeFromat).asSeconds();
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("PJh5")))

/***/ }),

/***/ "mDbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsForm_vue__ = __webpack_require__("6U8a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ff9f69_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsForm_vue__ = __webpack_require__("LdPi");
function injectStyle (ssrContext) {
  __webpack_require__("a87j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22ff9f69"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ff9f69_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mSmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_collection__ = __webpack_require__("wBFF");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/collections?include=sequences', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/collections/' + id).then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_collection__["a" /* default */](false, response.data.data);
    });
  },
  sequences: function sequences(id, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/collections/' + id + '/sequences', {
      params: query
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/collections', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/collections/' + id, data.prepareForSend());
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/collections', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  select: function select(data) {
    var collection = new __WEBPACK_IMPORTED_MODULE_2__models_collection__["a" /* default */](true);
    collection.nome = data;
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/collections', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(collection),
        limit: 100,
        orderBy: 'title'
      }
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/collections/' + id);
  },
  detachSequence: function detachSequence(collection, sequence) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('collections/' + collection + '/sequences/' + sequence);
  }
});

/***/ }),

/***/ "msTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("LwKy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643a8b4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("1wuq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643a8b4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mtF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('microtags-form',{attrs:{"microtag":_vm.microtag,"loader":_vm.loader,"showLabels":false},on:{"click":function($event){return _vm.storeMicrotag(_vm.microtag)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n4Di":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      loader: false,
      infoError: false,
      username: '',
      password: '',
      errorMessage: ''
    };
  },
  beforeCreate: function beforeCreate() {
    if (this.$store.state.isLogged) {
      this.$router.push('/');
    }
  },
  mounted: function mounted() {
    $('body').addClass('login-page');
  },

  methods: {
    login: function login() {
      var _this = this;

      this.loader = true;
      this.infoError = false;

      this.$store.dispatch('login', {
        username: this.username,
        password: this.password
      }).then(function (response) {
        return _this.$router.push('/');
      }).catch(function (error) {
        _this.infoError = true;
        _this.loader = false;
        _this.password = '';
        _this.errorMessage = error.response.data.hint + ': ' + error.response.data.message;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "nUgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('sequences-form',{attrs:{"sequence":_vm.sequence,"reel":_vm.reel,"loader":_vm.loader,"showLabels":false},on:{"click":function($event){return _vm.storeSequence(_vm.sequence)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nkGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('v-server-table',{ref:"keywords",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"keywords"},on:{"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading,"row-click":_vm.showKeyword},scopedSlots:_vm._u([{key:"actions",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o3Ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_keywords__ = __webpack_require__("Rii/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'keyword', 'loader', 'showLabels'],
  methods: {
    click: function click() {
      this.$emit('click', this.keyword);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.keyword);
    }
  },
  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      keywords: []
    };
  },

  computed: {
    donazione_tipi: function donazione_tipi() {
      return this.$store.state.decoder.decoders['_dDonationTypes'];
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_keywords__["a" /* default */].index().then(function (response) {
      _this.keywords = response.data.data;
    });
  },

  components: {}
});

/***/ }),

/***/ "o9cx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("yoF/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3d310e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("fCJ/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3d310e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oWEZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Person; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var Person = function () {
  function Person(data) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Person);

    if (data !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
    }
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Person, [{
    key: "prepareForSend",
    value: function prepareForSend() {
      var data = _.cloneDeep(this);
      return data;
    }
  }]);

  return Person;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "okgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Person; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__("lviy");






var Person = function () {
  function Person(data) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Person);

    if (data !== undefined) {
      data.nascita_data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filters__["c" /* dpParseDate */])(data.nascita_data);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
    }
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Person, [{
    key: 'prepareForSend',
    value: function prepareForSend() {
      var data = _.cloneDeep(this);
      data.nascita_data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filters__["d" /* dateFormatServer */])(data.nascita_data);
      return data;
    }
  }]);

  return Person;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "pcOG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pfo8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_persons__ = __webpack_require__("4eBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_funds__ = __webpack_require__("ybAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_filmformat__ = __webpack_require__("lJgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fine_uploader_wrappers__ = __webpack_require__("rm6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fine_uploader_wrappers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fine_uploader_wrappers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_fineuploader_dropzone__ = __webpack_require__("UNH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_masked_input__ = __webpack_require__("4q2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__ = __webpack_require__("fv+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__("I7CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// Import this component


// Import date picker css





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'fund', 'loader', 'showLabels', 'showSearch', 'showSave'],
  methods: {
    save: function save() {
      this.$emit('click', this.fund);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.fund);
    },
    saveArchiveWeb: function saveArchiveWeb() {
      this.$emit('save-archive-web', this.fund);
    },
    search: function search() {
      this.$emit('search', this.fund);
    },
    delImage: function delImage(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_funds__["a" /* default */].deleteImage(this.fund.id, id).then(function (response) {
        _this.fund.fundimages = response.data.data.fundimages;
        toastr.success('L\'immagine è stata rimossa correttamente');
      }).catch(function (response) {});
    },
    personsFind: function personsFind(query) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_persons__["a" /* default */].select(query).then(function (response) {
        _this2.persons = response.data.data;
      });
    }
  },
  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      persons: [],
      formati: [],
      uploader: new __WEBPACK_IMPORTED_MODULE_5_fine_uploader_wrappers___default.a({
        options: []
      })
    };
  },

  watch: {
    fund: function fund(val) {
      var _this3 = this;

      this.uploader = new __WEBPACK_IMPORTED_MODULE_5_fine_uploader_wrappers___default.a({
        options: {
          request: {
            endpoint: "https://api.cinescatti.it/v1" + '/funds/' + val.id + '/fundimage',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'image'
          },
          callbacks: {
            onComplete: function onComplete(id, name, response) {
              _this3.fund.fundimages = response.data.fundimages;
            }
          }
        }
      });
    }
  },
  computed: {
    donazione_tipi: function donazione_tipi() {
      return this.$store.state.decoder.decoders['_dDonationTypes'];
    },
    conservazione_stati: function conservazione_stati() {
      return this.$store.state.decoder.decoders['_dConservationState'];
    },
    ynp: function ynp() {
      return this.$store.state.decoder.decoders['_dYesNoPartial'];
    }
  },
  beforeCreate: function beforeCreate() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_3__api_filmformat__["a" /* default */].index().then(function (response) {
      _this4.formati = response.data.data;
    });
  },

  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default.a,
    vueSlider: __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default.a,
    Dropzone: __WEBPACK_IMPORTED_MODULE_6_vue_fineuploader_dropzone__["a" /* default */],
    MaskedInput: __WEBPACK_IMPORTED_MODULE_7_vue_masked_input__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "phwD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsShow_vue__ = __webpack_require__("8dO3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26ff9272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsShow_vue__ = __webpack_require__("wPpm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26ff9272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__("hQ4h");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("5ANv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q5jR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopBar_vue__ = __webpack_require__("dmV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar_vue__ = __webpack_require__("xRww");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Foot_vue__ = __webpack_require__("8dxS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'baseComponent',

  computed: {
    pageTitle: function pageTitle() {
      return this.$store.state.ui.pageTitle;
    },
    createButton: function createButton() {
      return this.$store.state.ui.createButton;
    }
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('fillProfile');
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (to.name !== 'login' || to.name !== 'logout') {
      if (sessionStorage.getItem('isLogged')) {
        next();
        return;
      }
      next('/login');
    }
  },
  data: function data() {
    return {
      backgroundColor: ''
    };
  },
  mounted: function mounted() {
    $('body').removeClass('login-page').addClass('skin-blue sidebar-mini sidebar-collapse');
  },


  methods: {
    afterEnter: function afterEnter(el) {},
    addBackgroundColor: function addBackgroundColor(backgroundColor) {
      this.backgroundColor = backgroundColor;
    }
  },

  components: {
    TopBar: __WEBPACK_IMPORTED_MODULE_0__TopBar_vue__["a" /* default */],
    SideBar: __WEBPACK_IMPORTED_MODULE_1__SideBar_vue__["a" /* default */],
    Foot: __WEBPACK_IMPORTED_MODULE_2__Foot_vue__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "qinV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('persons-form',{attrs:{"person":_vm.person,"disabled":_vm.disabled,"showLabels":true},on:{"activate-mod":function($event){return _vm.activateMod()},"click":function($event){return _vm.updatePerson()}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qmJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_funds__ = __webpack_require__("ybAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("zeKe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ReelsTab__ = __webpack_require__("Jqvb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_reels__ = __webpack_require__("R3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_reel__ = __webpack_require__("gQ+i");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    fundsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */],
    reelsTab: __WEBPACK_IMPORTED_MODULE_3__components_ReelsTab__["a" /* default */]
  },

  data: function data() {
    return {
      fund: false,
      disabled: true,
      interval: null,
      massiveReelsInsert: 1
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.fund = response;
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_ACTUAL_FUND, _.cloneDeep(response));
    });
    this.$emit('addBackgroundColor', 'rgb(138,163,157)');
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Scheda fondo',
      createButton: {
        display: true,
        text: 'Nuovo fondo',
        to: '/fund'
      }
    });
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].update(_this2.$route.params.id, _this2.fund);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updateFund: function updateFund() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].update(this.$route.params.id, this.fund).then(function (response) {
        toastr.success('Il fondo è stato salvato correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    },
    saveArchiveWeb: function saveArchiveWeb() {
      var _this4 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].saveArchiveWeb(this.$route.params.id).then(function (response) {
        toastr.success('Il fondo è stato salvato correttamente');
        _this4.loader = false;
        _this4.disabled = true;
      }).catch(function (response) {
        _this4.loader = false;
      });
    },
    requestFunction: function requestFunction(query) {
      return __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].reels(this.$route.params.id, query);
    },
    reelsMassiveInsert: function reelsMassiveInsert() {
      var _this5 = this;

      this.$refs.reelsTab.toggleLoading();
      return __WEBPACK_IMPORTED_MODULE_4__api_reels__["a" /* default */].storeMassive(new __WEBPACK_IMPORTED_MODULE_5__models_reel__["a" /* default */](true, {
        count: this.massiveReelsInsert,
        fund_id: this.fund.id
      }, this.$store.state.profile.profile.person.data)).then(function (response) {
        _this5.$refs.reelsTab.refresh();
        _this5.$refs.reelsTab.toggleLoading();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("vQJi")))

/***/ }),

/***/ "qmkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_macrotags__ = __webpack_require__("68s8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_microtags__ = __webpack_require__("jzQX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_places__ = __webpack_require__("sWWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_persons__ = __webpack_require__("4eBV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['description', 'disabled', 'reelDescription'],
  data: function data() {
    return {
      persons: [],
      places: [],
      // keywords: [],
      macrotags: [],
      microtags: []
    };
  },

  methods: {
    personsFind: function personsFind(query) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__api_persons__["a" /* default */].select(query).then(function (response) {
        _this.persons = response.data.data;
      });
    },
    placesFind: function placesFind(query) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_places__["a" /* default */].select(query).then(function (response) {
        _this2.places = response.data.data;
      });
    },

    // keywordsFind (query) {
    //   keywordsApi.select(query)
    //     .then((response) => {
    //       this.keywords = response.data.data
    //     })
    // },
    macrotagsFind: function macrotagsFind(query) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__api_macrotags__["a" /* default */].select(query).then(function (response) {
        _this3.macrotags = response.data.data;
      });
    },
    microtagsFind: function microtagsFind(query) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].select(query).then(function (response) {
        _this4.microtags = response.data.data;
      });
    }
  },
  computed: {
    suoni: function suoni() {
      return this.$store.state.decoder.decoders['_dSound'];
    },
    cromatismi: function cromatismi() {
      return this.$store.state.decoder.decoders['_dColor'];
    },
    ynp: function ynp() {
      return this.$store.state.decoder.decoders['_dYesNoPartial'];
    }
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  }
});

/***/ }),

/***/ "qoDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+qt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rMyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");




var isTokenRefreshing = false;

var client = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://api.cinescatti.it/v1",
  timeout: 150000,
  headers: {
    'Accept': 'application/json'
  }
});

client.interceptors.request.use(function (config) {
  var accessToken = sessionStorage.getItem('access_token');

  if (accessToken) {
    config.headers['Authorization'] = 'Bearer ' + accessToken;
  }

  return config;
});

client.interceptors.response.use(function (response) {
  if (false) {
    console.log(response);
  }

  return response;
}, function (error) {
  if (false) {
    console.log(error);
  }

  if (typeof error.response !== 'undefined') {
    var originalRequest = error.config;
    if (error.response.status === 401 && !isTokenRefreshing) {
      isTokenRefreshing = true;
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('refreshToken', {
        refresh_token: sessionStorage.getItem('refresh_token')
      }).then(function (response) {
        originalRequest.headers['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token;
        return client(originalRequest);
      }).catch(function () {
        toastr.warning('Login scaduto');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
      });
    }

    if (error.response.status === 404) {
      originalRequest._retry = true;
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
      return;
    }

    if (error.response.status === 500) {
      toastr.error(error.response.data.message, 'Errore 500');
    }

    if (error.response.status === 422) {
      var errorMessage = '';
      for (var name in error.response.data.errors) {
        var errors = error.response.data.errors[name];
        for (var _error in errors) {
          errorMessage += errors[_error] + '<br>';
        }
      }
      toastr.error(errorMessage, 'Errore inserimento dati');
    }

    if (error.response.status === 400) {
      toastr.error(error.response.data.message, 'Errore 400');
    }
  } else if (typeof error.code !== 'undefined' && error.code === 'ECONNABORTED') {
    toastr.error('Connection aborted: ' + error.message);
  } else {
    toastr.error(error.message);
  }

  // Do something with response error
  throw error;
});


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "s7RQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_microtags__ = __webpack_require__("jzQX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_macrotags__ = __webpack_require__("68s8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled', 'microtag', 'loader', 'showLabels'],
  methods: {
    click: function click() {
      if (this.microtag.macrotag === undefined) {
        toastr.error('Devi inserire il macrotag padre');
        return;
      }
      this.$emit('click', this.microtag);
    },
    error: function error(e) {
      console.log(e);
    },
    activateMod: function activateMod() {
      this.$emit('activate-mod', this.microtag);
    },
    macrotagsFind: function macrotagsFind(query) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_macrotags__["a" /* default */].select(query).then(function (response) {
        _this.macrotags = response.data.data;
      });
    }
  },
  data: function data() {
    return {
      config: {
        format: __WEBPACK_IMPORTED_MODULE_0__filters__["e" /* clientDateFormat */]
      },
      macrotags: [],
      microtags: []
    };
  },

  computed: {
    donazione_tipi: function donazione_tipi() {
      return this.$store.state.decoder.decoders['_dDonationTypes'];
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__api_microtags__["a" /* default */].index().then(function (response) {
      _this2.microtags = response.data.data;
    });
  },

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "sWWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_place__ = __webpack_require__("oXUi");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/places', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/places/' + id).then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_place__["a" /* default */](response.data.data);
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/places', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/places/' + id, data.prepareForSend());
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/places', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  select: function select(data) {
    var place = new __WEBPACK_IMPORTED_MODULE_2__models_place__["a" /* default */]();
    place.nome = data;
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/places', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(place),
        limit: 100,
        orderBy: 'nome'
      }
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/places/' + id);
  }
});

/***/ }),

/***/ "sbQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsIndex_vue__ = __webpack_require__("/VFb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_591caa57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsIndex_vue__ = __webpack_require__("v/pC");
function injectStyle (ssrContext) {
  __webpack_require__("XKo0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_591caa57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "suPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("tpFK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371d3dd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("Tzwp");
function injectStyle (ssrContext) {
  __webpack_require__("pcOG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371d3dd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tGQc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("Yt18");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9831d7f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("tLo5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9831d7f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tLo5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('microtags-form',{attrs:{"microtag":_vm.microtag,"disabled":_vm.disabled,"showLabels":true},on:{"activate-mod":function($event){return _vm.activateMod()},"click":function($event){return _vm.updateMicrotag()}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tpFK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_reels__ = __webpack_require__("R3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("xgCv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_sequences__ = __webpack_require__("WBeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_sequence__ = __webpack_require__("3vTe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    reelsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },

  data: function data() {
    return {
      reel: false,
      fund: false,
      abs: '',
      columns: ['progressivo', 'abstract', 'actions'],
      options: {
        saveState: false,
        headings: {},
        sortable: ['progressivo'],
        columnsClasses: {
          'progressivo': 'progressivo'
        },
        requestFunction: function requestFunction(query) {
          return __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].sequences(this.$route.params.id, query);
        }
      },
      disabled: true,
      interval: null,
      showMap: false
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.reel = response;
      _this.fund = response.fund.data;
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_ACTUAL_REEL, _.cloneDeep(response));
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_ACTUAL_FUND, response.fund.data);
    });
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Scheda bobina',
      createButton: {
        display: true,
        text: 'Nuova bobina',
        to: '/reel'
      }
    });
    this.$emit('addBackgroundColor', 'rgb(202,94,66)');
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].update(_this2.$route.params.id, _this2.reel);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    showSequence: function showSequence(row) {
      this.$router.push({ name: 'sequencesShow', params: { id: row.row.id, showMap: false } });
    },
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updateReel: function updateReel() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].update(this.$route.params.id, this.reel).then(function (response) {
        toastr.success('La bobina è stata salvata correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    },
    saveArchiveWeb: function saveArchiveWeb() {
      var _this4 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].saveArchiveWeb(this.$route.params.id).then(function (response) {
        toastr.success('La bobina è stata salvata correttamente');
        _this4.loader = false;
        _this4.disabled = true;
      }).catch(function (response) {
        _this4.loader = false;
      });
    },
    prev: function prev() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].prev(this.reel.id).then(function (response) {
        _this5.$router.push({ name: 'reelsShow', params: { id: response.data } });
      });
    },
    next: function next() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_reels__["a" /* default */].next(this.reel.id).then(function (response) {
        _this6.$router.push({ name: 'reelsShow', params: { id: response.data } });
      });
    },
    storeSequence: function storeSequence() {
      var _this7 = this;

      this.loader = true;
      __WEBPACK_IMPORTED_MODULE_3__api_sequences__["a" /* default */].store(new __WEBPACK_IMPORTED_MODULE_4__models_sequence__["a" /* default */](false, { reel_id: this.reel.id })).then(function (response) {
        toastr.success('La sequenza è stata inserita correttamente');
        _this7.$refs.sequences.refresh();
      }).catch(function (response) {
        _this7.loader = false;
      });
    },
    removeSequence: function removeSequence(id) {
      var _this8 = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_3__api_sequences__["a" /* default */].delete(id).then(function (response) {
          _this8.$refs.sequences.refresh();
          toastr.success('La sequenza è stata rimossa correttamente');
          _this8.loading = false;
        }).catch(function (response) {
          _this8.loading = false;
        });
      }
    },
    updateSequence: function updateSequence(sequence) {
      var _this9 = this;

      this.loader = true;
      var sequenceToSave = new __WEBPACK_IMPORTED_MODULE_4__models_sequence__["a" /* default */](false, sequence);
      sequenceToSave.abstract = this.$refs['abstract-' + sequenceToSave.id].value;
      __WEBPACK_IMPORTED_MODULE_3__api_sequences__["a" /* default */].update(sequenceToSave.id, sequenceToSave).then(function (response) {
        toastr.success('La sequenza è stata salvata correttamente');
        _this9.loader = false;
      }).catch(function (response) {
        _this9.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("vQJi")))

/***/ }),

/***/ "txAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u3pw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-right"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.massParam),expression:"massParam"}],staticClass:"form-control",attrs:{"id":"massParam","name":"massParam"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.massParam=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"digit"}},[_vm._v("Digitalizzazione")]),_vm._v(" "),_c('option',{attrs:{"value":"restauro"}},[_vm._v("Restauro")]),_vm._v(" "),_c('option',{attrs:{"value":"catalogato"}},[_vm._v("Catalogato")]),_vm._v(" "),_c('option',{attrs:{"value":"web_enabled"}},[_vm._v("Pubblicato archivio web")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-right"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.massValue),expression:"massValue"}],staticClass:"form-control",attrs:{"id":"massValue","name":"massValue"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.massValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.ynp),function(desc,id){return _c('option',{domProps:{"value":id}},[_vm._v("\n            "+_vm._s(desc)+"\n          ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-right"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"disabled":_vm.massParam === null || _vm.massValue === null || _vm.massSelected.length === 0},on:{"click":function($event){$event.preventDefault();return _vm.saveMassParam.apply(null, arguments)}}},[(_vm.saveMassParamLoader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n          Salva\n        ")])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-server-table',{ref:"reels",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"reels"},on:{"row-click":_vm.showReel,"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading},scopedSlots:_vm._u([{key:"id",fn:function(props){return [_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.massSelected),expression:"massSelected"}],attrs:{"type":"checkbox"},domProps:{"value":props.row.id,"checked":Array.isArray(_vm.massSelected)?_vm._i(_vm.massSelected,props.row.id)>-1:(_vm.massSelected)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){var $$a=_vm.massSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=props.row.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.massSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.massSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.massSelected=$$c}}}})])]}},{key:"titolo_originale",fn:function(props){return [_c('div',{staticStyle:{"width":"150px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n          "+_vm._s(props.row.titolo_originale)+"\n        ")])]}},{key:"titolo_attribuito",fn:function(props){return [_c('div',{staticStyle:{"width":"150px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n          "+_vm._s(props.row.titolo_attribuito)+"\n        ")])]}},{key:"formato",fn:function(props){return [(props.row.filmFormats)?_c('ul',_vm._l((props.row.filmFormats.data),function(formato){return _c('li',[_vm._v("\n            "+_vm._s(formato.name)+"\n          ")])}),0):_vm._e()]}},{key:"cromatismo",fn:function(props){return [(props.row.description)?_c('div',[_vm._v("\n          "+_vm._s(_vm._f("decodeValue")(props.row.description.data.cromatismo,'_dColor'))+"\n        ")]):_vm._e()]}},{key:"suono",fn:function(props){return [(props.row.description)?_c('div',[_vm._v("\n          "+_vm._s(_vm._f("decodeValue")(props.row.description.data.suono,'_dYesNoPartial'))+"\n        ")]):_vm._e()]}},{key:"digit",fn:function(props){return [_c('div',{staticClass:"text-center"},[(props.row.digit === 1)?_c('span',{staticClass:"label label-success"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.digit === 2)?_c('span',{staticClass:"label label-warning"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.digit === 0 | props.row.digit === null)?_c('span',{staticClass:"label label-danger"},[_c('span',{staticClass:"glyphicon glyphicon-remove"})]):_vm._e()])]}},{key:"durata",fn:function(props){return [_c('div',[_vm._v("\n          "+_vm._s(_vm._f("secondsToTime")(props.row.durata))+"\n        ")])]}},{key:"restauro",fn:function(props){return [_c('div',{staticClass:"text-center"},[(props.row.restauro === 1)?_c('span',{staticClass:"label label-success"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.restauro === 2)?_c('span',{staticClass:"label label-warning"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e(),_vm._v(" "),(props.row.restauro === 0 || props.row.restauro === null)?_c('span',{staticClass:"label label-danger"},[_c('span',{staticClass:"glyphicon glyphicon-remove"})]):_vm._e()])]}},{key:"catalogato",fn:function(props){return [_c('div',{staticClass:"text-center"},[(props.row.catalogato === 1)?_c('span',{staticClass:"label label-success"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):(props.row.catalogato === 0)?_c('span',{staticClass:"label label-danger"},[_c('span',{staticClass:"glyphicon glyphicon-remove"})]):(props.row.catalogato === 2 | props.row.catalogato === null)?_c('span',{staticClass:"label label-warning"},[_c('span',{staticClass:"glyphicon glyphicon-ok"})]):_vm._e()])]}},{key:"actions",fn:function(props){return [_c('div',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3  col-md-offset-3 text-right"},[_c('strong',[_vm._v("Setta valori a bobine selezionate:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ur+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v("Versione")]),_vm._v(" "+_vm._s(_vm.version)+"\n    ")]),_vm._v(" "),_c('strong',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.cinescatti.it"}},[_vm._v("Cinescatti")]),_vm._v(".")]),_vm._v("\n    Tutti i diritti riservati.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v/pC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('v-server-table',{ref:"collections",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"collections"},on:{"loading":_vm.toggleLoading,"loaded":_vm.toggleLoading,"row-click":_vm.showCollection},scopedSlots:_vm._u([{key:"sequences",fn:function(props){return [_c('div',[_vm._v("\n                "+_vm._s(props.row.sequences.data.length)+"\n              ")])]}},{key:"actions",fn:function(props){return [_c('div',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.remove(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])]}}])})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vGh4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vwNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.macrotag)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.macrotag.macrotag),expression:"macrotag.macrotag"}],staticClass:"form-control",attrs:{"type":"text","id":"nome","name":"nome","disabled":_vm.disabled},domProps:{"value":(_vm.macrotag.macrotag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.macrotag, "macrotag", $event.target.value)}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-md-offset-10"},[(!_vm.disabled)?_c('button',{staticClass:"btn btn-success btn-block"},[(_vm.loader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                Salva\n                            ")]):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){$event.preventDefault();return _vm.activateMod.apply(null, arguments)}}},[_vm._v("\n                                Attiva modifiche\n                            ")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w54t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_macrotags__ = __webpack_require__("68s8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_vue__ = __webpack_require__("Yrvy");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    macrotagsForm: __WEBPACK_IMPORTED_MODULE_2__Form_vue__["a" /* default */]
  },

  data: function data() {
    return {
      keyword: false,
      disabled: true,
      interval: null
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_macrotags__["a" /* default */].show(this.$route.params.id).then(function (response) {
      _this.keyword = response;
    });
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Macrotags inseriti',
      createButton: {
        display: true,
        text: 'Nuova keyword',
        to: '/keyword'
      }
    });
    this.interval = setInterval(function () {
      if (!_this2.disabled) {
        __WEBPACK_IMPORTED_MODULE_1__api_macrotags__["a" /* default */].update(_this2.$route.params.id, _this2.keyword);
      }
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    activateMod: function activateMod() {
      this.disabled = !this.disabled;
    },
    updateMacrotag: function updateMacrotag() {
      var _this3 = this;

      this.loader = true;
      return __WEBPACK_IMPORTED_MODULE_1__api_macrotags__["a" /* default */].update(this.$route.params.id, this.keyword).then(function (response) {
        toastr.success('La keyword è stata salvata correttamente');
        _this3.loader = false;
        _this3.disabled = true;
      }).catch(function (response) {
        _this3.loader = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "wB/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wBFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__baseModel__ = __webpack_require__("Lb/K");










var Collection = function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Collection, _BaseModel);

  function Collection(create, data) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this));

    _this.sequences = {
      data: []
    };

    if (create) {
      _this.isNew = true;
    }
    if (data !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'prepareForSend',
    value: function prepareForSend() {
      return _.cloneDeep(this);
    }
  }, {
    key: 'prepareQueryForSearch',
    value: function prepareQueryForSearch() {
      // this.anno_inizio = (this.range_anni[0] !== anno_inizio_def) ? this.range_anni[0] : null
      // this.anno_fine = (this.range_anni[1] !== anno_fine_def) ? this.range_anni[1] : null
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(Collection.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection.prototype), 'prepareQueryForSearch', this).call(this, this);
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8__baseModel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Collection);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "wPpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('collections-form',{attrs:{"collection":_vm.collection,"disabled":_vm.disabled,"showLabels":true},on:{"activate-mod":function($event){return _vm.activateMod()},"click":function($event){return _vm.updateCollection(_vm.collection)},"change-collection-prop":_vm.changeCollectionProps}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-md-offset-3 text-right"},[_c('multiselect',{attrs:{"options":_vm.funds,"track-by":"id","label":"denominazione","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"funds","name":"funds","clear-on-select":false,"searchable":true},on:{"search-change":_vm.fundsFind,"select":_vm.searchFundSelected},model:{value:(_vm.searchFund),callback:function ($$v) {_vm.searchFund=$$v},expression:"searchFund"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-right"},[_c('multiselect',{attrs:{"options":_vm.reels,"track-by":"id","label":"identificativo","placeholder":"seleziona","SelectLabel":"seleziona","SelectedLabel":"selezionato","DeselectLabel":"deseleziona","id":"reels","name":"reels","clear-on-select":false,"searchable":true,"disabled":_vm.reels.length < 1},model:{value:(_vm.searchReel),callback:function ($$v) {_vm.searchReel=$$v},expression:"searchReel"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-right"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"disabled":_vm.searchFund === null || _vm.searchReel === null},on:{"click":function($event){$event.preventDefault();return _vm.storeSequence.apply(null, arguments)}}},[(_vm.storeSequenceLoader)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v("\n                                Inserisci nuova sequenza\n                            ")])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-server-table',{ref:"sequences",attrs:{"url":"","columns":_vm.columns,"options":_vm.options,"name":"sequences"},on:{"row-click":_vm.showSequence},scopedSlots:_vm._u([{key:"reel_identificativo",fn:function(props){return [_c('div',{staticClass:"form-group"},[_c('router-link',{attrs:{"to":{ name: 'reelsShow', params: { id: props.row.reel_id }},"tag":"h4"}},[_c('span',{staticClass:"label label-default"},[_c('strong',[_vm._v(_vm._s(props.row.reel_identificativo))])])])],1)]}},{key:"actions",fn:function(props){return [_c('div',[(_vm.$accessControl.isOperator(_vm.$store.state.profile.profile))?_c('button',{staticClass:"btn btn-warning btn-sm",on:{"click":function($event){$event.stopPropagation();return _vm.detachSequence(props.row.id)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])]}}])})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Sequenze")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wh6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("55Ku");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_984bfb82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("3lBT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_984bfb82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getDecoders');
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0753935d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("WoY1");
function injectStyle (ssrContext) {
  __webpack_require__("U/4w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0753935d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xLnc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Microtag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var Microtag = function () {
  function Microtag(data) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Microtag);

    if (data !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this[key] = value;
      });
    }
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Microtag, [{
    key: "prepareForSend",
    value: function prepareForSend() {
      return _.cloneDeep(this);
    }
  }]);

  return Microtag;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "xRww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22789c19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("34tu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22789c19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xgCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("AylU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b087d454_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("S+XY");
function injectStyle (ssrContext) {
  __webpack_require__("wB/S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b087d454"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b087d454_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y0LK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_funds__ = __webpack_require__("ybAY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FundsTab',
  props: {
    requestFunction: Function
  },
  data: function data() {
    return {
      columns: ['id', 'denominazione', 'identificativo', 'acquisizione_data', 'acquisizione_tipo', 'consistenza', 'formati', 'digitalizzazione', 'catalogazione', 'intervista', 'updated_at', 'actions'],
      options: {
        headings: {
          'acquisizione_data': 'Data acquisizione',
          'acquisizione_tipo': 'Tipologia acquisizione',
          'updated_at': 'Ultima modifica'
        },
        sortable: ['denominazione', 'acquisizione_data', 'acquisizione_tipo', 'consistenza', 'digitalizzazione', 'catalogazione', 'intervista'],
        requestFunction: this.$props.requestFunction
      },
      loading: false,
      selected: []

    };
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm('Sei sicuro di procedere?')) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api_funds__["a" /* default */].delete(id).then(function (response) {
          _this.$refs.funds.refresh();
          toastr.success('Il fondo è stato rimosso correttamente');
          _this.loading = false;
        }).catch(function (response) {
          _this.loading = false;
        });
      }
    },
    toggleLoading: function toggleLoading() {
      this.loading = !this.loading;
    },
    showFund: function showFund(row) {
      this.$router.push({ name: 'fundsShow', params: { id: row.row.id } });
    },
    refresh: function refresh() {
      this.$refs.funds.refresh();
    },
    doExport: function doExport(type) {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_funds__["a" /* default */].export(type, this.selected).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        var filename = '';
        var disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        _this2.loading = false;
      }).catch(function (response) {
        _this2.loading = false;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ }),

/***/ "yAC8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yXK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('persons-form',{attrs:{"person":_vm.person,"loader":_vm.loader,"showLabels":false},on:{"click":function($event){return _vm.storePerson(_vm.person)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ybAY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("rMyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_fund__ = __webpack_require__("FHMM");




/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/funds', {
      params: query
    });
  },
  show: function show(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/funds/' + id).then(function (response) {
      return new __WEBPACK_IMPORTED_MODULE_2__models_fund__["a" /* default */](false, response.data.data);
    });
  },
  reels: function reels(id, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/funds/' + id + '/reels', {
      params: query
    });
  },
  store: function store(data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/funds', data.prepareForSend());
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].patch('/funds/' + id, data.prepareForSend());
  },
  saveArchiveWeb: function saveArchiveWeb(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/funds-save-archive-web/' + id);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/funds/' + id);
  },
  search: function search(data, query) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/funds', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    });
  },
  select: function select(data) {
    var fund = new __WEBPACK_IMPORTED_MODULE_2__models_fund__["a" /* default */]();
    fund.denominazione = data;
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/funds?include=reels', {
      params: {
        filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(fund),
        limit: 100,
        orderBy: 'denominazione'
      }
    });
  },
  deleteImage: function deleteImage(fundId, imageId) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].delete('/funds/' + fundId + '/fundimage/' + imageId);
  },
  export: function _export(type, data) {
    __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].defaults.responseType = 'blob';
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].get('/funds-export/' + type, {
      params: {
        ids: data
      }
    }).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].defaults.responseType = 'json';
      return response;
    });
  },
  refreshContents: function refreshContents() {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* client */].post('/refresh-contents');
  }
});

/***/ }),

/***/ "yhWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsCreate_vue__ = __webpack_require__("GnNy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a568d6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsCreate_vue__ = __webpack_require__("3pgH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionsCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a568d6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionsCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yoF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile',

  data: function data() {
    return {
      loaderProfile: false,
      loaderPassword: false,
      newPassword: null,
      newPasswordRepeat: null
    };
  },
  beforeCreate: function beforeCreate() {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.$store.state.profile.profile) === undefined) {
      this.$router.replace('/');
    }
  },


  computed: {
    profile: function profile() {
      return _.cloneDeep(this.$store.state.profile.profile);
    }
  },

  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Profilo',
      createButton: false
    });
  },


  methods: {
    updateProfile: function updateProfile() {
      var _this = this;

      this.$validator.validateAll('profile').then(function (result) {
        if (result) {
          _this.loaderProfile = true;
          _this.$store.dispatch('updateProfile', _this.profile).then(function (response) {
            toastr.success('Profilo modificato correttamente');
            _this.loaderProfile = false;
          });
        } else {
          toastr.error('Sono presenti errori nel form');
        }
      });
    },
    password: function password() {
      var _this2 = this;

      this.$validator.validateAll('newPassword').then(function (result) {
        if (result) {
          _this2.loaderPassword = true;
          _this2.$store.dispatch('password', _this2.newPassword).then(function (response) {
            toastr.success('Password modificata correttamente');
            _this2.loaderPassword = false;
          });
        } else {
          toastr.error('Sono presenti errori nel form');
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("vQJi")))

/***/ }),

/***/ "yt2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundsTab_vue__ = __webpack_require__("y0LK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d2ac0d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundsTab_vue__ = __webpack_require__("FBz5");
function injectStyle (ssrContext) {
  __webpack_require__("txAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d2ac0d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d2ac0d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zXzZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "zeKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("pfo8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5643e3dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("k3bd");
function injectStyle (ssrContext) {
  __webpack_require__("/Ygb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5643e3dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5643e3dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zfG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zjIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_funds__ = __webpack_require__("ybAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FundsTab__ = __webpack_require__("yt2h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    fundsTab: __WEBPACK_IMPORTED_MODULE_2__components_FundsTab__["a" /* default */]
  },

  data: function data() {
    return {
      isRefreshing: false
    };
  },


  computed: {
    isOperator: function isOperator() {
      return this.$accessControl.isOperator(this.$store.state.profile.profile);
    }
  },

  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* default */].SET_HEADER_STATE, {
      pageTitle: 'Fondi inseriti',
      createButton: {
        display: true,
        text: 'Nuovo fondo',
        to: 'fund'
      }
    });
    this.$emit('addBackgroundColor', 'rgb(244,233,215)');
  },


  methods: {
    requestFunction: function requestFunction(query) {
      return __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].index(query);
    },
    confirmRefreshArchiveWeb: function confirmRefreshArchiveWeb() {
      if (confirm('Sei sicuro di voler aggiornare l\'archivio web? Questa operazione potrebbe richiedere alcuni minuti.')) {
        this.refreshArchiveWeb();
      }
    },
    refreshArchiveWeb: function refreshArchiveWeb() {
      var _this = this;

      this.isRefreshing = true;
      __WEBPACK_IMPORTED_MODULE_1__api_funds__["a" /* default */].refreshContents().then(function (response) {
        _this.isRefreshing = false;
        toastr.success(response.data.message || 'Archivio web aggiornato con successo');
      }).catch(function (error) {
        _this.isRefreshing = false;
        if (error.response && error.response.data && error.response.data.message) {
          toastr.error(error.response.data.message);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vQJi")))

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.926a486885594d500504.js